var S = {};
var _learnq = _learnq || [];

 /*============================================================================
Plyr setup
==============================================================================*/


  var videoEl = {
    playButtonIcon:'<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
    playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
    muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
    progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
    volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
    fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
  }

  var videoControls = videoEl.playButtonIcon + '<div class="plyr__controls">' + videoEl.playButton + videoEl.progressInput + videoEl.muteButton + videoEl.volume + videoEl.fullscreen + '</div>';
  var globalVideoPlayers = [];
  var videoPlayers = [];
  var videosInRecommendedProductsPlayer;

  videoFeature = {
    init: function() {

      this.setupVideoPlayer();

    },
    setupVideoPlayer: function() {
      var productVideos = document.querySelectorAll('[data-html5-video] video, [data-youtube-video], [data-video-element]');

      var setupVideoPlayers = Plyr.setup(productVideos, {
        controls: videoControls,
        ratio: this.aspect_ratio,
        autoplay: true,
        muted: true, volume: 0,
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });

      // Moves players into global array so that we can target them for play/pause on global level
      if (globalVideoPlayers) {
        $.each(setupVideoPlayers, function(index, player) {
          globalVideoPlayers.push(player);
        })
      }

      var videoLooping = $('[data-video-loop]').data('video-loop') || false;
      $.each(setupVideoPlayers, function(index, player) {
        player.loop = videoLooping;
        videoPlayers.push(player);
      });

      this.setupListeners();
    },
    setupListeners: function() {
      // Adds plyr video id to video wrapper
      $.each(videoPlayers, function(index, player) {
        var id = player.id || player.media.dataset.plyrVideoId;
        var $video;
// 		console.log(player)
        player.on('ready', event => {
          const player = event.detail.plyr;
        });
        if (player.isHTML5) {
          $video = $(player.elements.wrapper).find('video');
          $video.attr('data-plyr-video-id', id);
        }
      })

      // When a video is playing, pause any other instances
      $.each(globalVideoPlayers, function(index, player) {
        player.on('play', function(event) {
          var instance = event.detail.plyr;
          $.each(globalVideoPlayers, function(index, player) {
            if (instance.id != player.id ) {
              player.pause();
            }
          })
        })
      })
    },
    enableVideoOnHover: function($thumbnail) {

      var $html5Video = $thumbnail.find('[data-html5-video]');
      var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
      var videoID;

      if ($html5Video.length > 0) {
        videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
      } else if ($youtubeVideo.length > 0) {
        videoID = $youtubeVideo.find('iframe').attr('id');
      }

      if (videoID) {
        $.each(videoPlayers, function(index, player) {

          if (player.id == videoID || player.media.id == videoID) {
            player.toggleControls(false);
            player.muted = true;
            player.play();
          }
        })
      }
    },
    disableVideoOnHover: function($thumbnail) {
      var $html5Video = $thumbnail.find('[data-html5-video]');
      var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
      var videoID;

      if ($html5Video.length > 0) {
        videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
      } else if ($youtubeVideo.length > 0) {
        videoID = $youtubeVideo.find('iframe').attr('id');
      }

      if (videoID) {
        $.each(videoPlayers, function(index, player) {
          if (player.id == videoID || player.media.id == videoID) {
            if (player.playing) {
              player.pause();
            }
          }
        })
      }
    }
  }



jQuery(document).ready(function($) {


  S.size = {}
  S.size.all = function() {
    S.size.windowW = $(window).outerWidth();
    S.size.windowH = $(window).outerHeight();
    S.size.header = $(".header-interior").outerHeight();

    S.isDesktop = false;
    S.isTablet = false;
    S.isMobile = false;

    // console.log("window: " + S.size.windowW);

    if (S.size.windowW > 1024) {
      S.isDesktop = true;
    } else if (S.size.windowW > 767) {
      S.isTablet = true;
    } else {
      S.isMobile = true;
    }
  }

  S.vars = {}
  S.vars.loaderTime = 2210;
  /* SWIPER */
  S.swiper = {}

  S.swiper.init = function($s) {
    if (!$s) {
      $s = $("#page-content");
    }

    $s.find(".swiper-container").each(function() {
      var $swiper = $(this);
//       console.log($swiper)

      var swiper_args = new Array();

      if ($(this).hasClass("hero-swiper")) {
        var slideauto = false;
        var slidepagi = false;
        var autotimeout = parseInt($(this).attr('data-autoslide'));
        console.log('autotimeout',autotimeout)
//         console.log($(this).find(".swiper-slide").length)
        if ($(this).find(".swiper-slide").length > 1) {
          slideauto = {
            delay: (autotimeout>0)?(autotimeout*1000):false,
          };
          slidepagi = {
            el: '.swiper-pagination',
            clickable: true
          };
          swiper_args = {
            loop: true,
            autoplay: (autotimeout>0)?slideauto:false,
            simulateTouch: false,
            slidesPerView: 'auto',
            centeredSlides: false,
            pagination: slidepagi,
            navigation: false,
            disableOnInteraction: false,
            roundLengths: true,
            on: {
              init: function() {
                if ($("body").hasClass("body--index")) {
                  var $s = $(this)[0];
                  $s.autoplay.stop();
                  setTimeout(function() {
//                     $s.autoplay.start();
                  }, S.vars.loaderTime + 1500)
                }
              }
            }
          }
        }
        else{
          swiper_args = {
            loop: false,
            draggable:false,
            autoplay: false,
            simulateTouch: false,
            slidesPerView: 'auto',
            centeredSlides: false,
            pagination: slidepagi,
            navigation: false,
            disableOnInteraction: false,
            roundLengths: true,
            on: {
              init: function() {
                if ($("body").hasClass("body--index")) {
                  var $s = $(this)[0];
                  $s.autoplay.stop();
                  setTimeout(function() {
//                     $s.autoplay.start();
                  }, S.vars.loaderTime + 1500)
                }
              }
            },
            breakpoints: {
              768: {
                loop: false,
                draggable:false,
              }
            }
          }
        }


      } else if ($(this).hasClass("style-guide-swiper")) {
//         console.log($(this))
        if($('body').hasClass('body--page-community')){
          var parent = $(this);
          if($(this).find('.swiper-slide').length < 3){
            console.log($(this).find('.swiper-slide').length)
            swiper_args = {
              loop:false,
              spaceBetween: 30,
              observer: true,
              observeParents: true,
              imulateTouch: false,
              autoplay: false,
              slidesPerView: 'auto',
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              on: {
                init: function() {
                  var $p = $(this)[0].$el.parents("section.style-guide-toggle");
                  if(parent.find('.swiper-slide').length==2){
                    parent.addClass('has-two-slides');
                  }
                  var $s = $(this)[0];
//                   if ($p.length) {
//                     var $tab = $p.find(".tab");
//                     if ($tab.length) {
//                       $tab.each(function() {
//                         $(this).click(function(e) {
//                           e.preventDefault();
//                           var i = $(this).index();
//                           // console.log("index: " + i);
//                           $s.slideToLoop(i);
//                         })
//                       })
//                       var $tab = $p.find(".tab:nth-child(1)");
//                       if ($tab.length) {
//                         $tab.addClass("active");
//                       }
//                     }
//                   }
                },
                slideChange: function () {
                  var i = $(this)[0].realIndex + 1;
                  console.log(i)
                  $($(this)[0].$el).find('.swiper-slide').removeClass('swiper-slide-active');
                  $($(this)[0].$el).find('.swiper-slide:eq('+$(this)[0].realIndex+')').addClass('swiper-slide-active');
                },
                slideChangeTransitionEnd:function () {
                  var i = $(this)[0].realIndex + 1;
                  console.log('slideChangeTransitionEnd',i)
                  $($(this)[0].$el).find('.swiper-slide').removeClass('swiper-slide-active');
                  $($(this)[0].$el).find('.swiper-slide:eq('+$(this)[0].realIndex+')').addClass('swiper-slide-active');
                },
              },
            }
          }
          else{
            swiper_args = {
            loop: false,
            observer: true,
            observeParents: true,
            autoplay: false,
            slidesPerView: 'auto',
            centeredSlides: true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            on: {
              init: function() {
                var $p = $(this)[0].$el.parents("section.style-guide-toggle");
                //                 console.log($(this))
                var $s = $(this)[0];
                if ($p.length) {
                  var $tab = $p.find(".tab");
                  if ($tab.length) {
                    $tab.each(function() {
                      $(this).click(function(e) {
                        e.preventDefault();
                        var i = $(this).index();
                        // console.log("index: " + i);
//                         $s.slideToLoop(i);
                      })
                    })
                    var $tab = $p.find(".tab:nth-child(1)");
                    if ($tab.length) {
//                       $tab.addClass("active");
                    }
                  }
                }
              },
              slideChange: function () {
                var i = $(this)[0].realIndex + 1;
                var $p = $(this)[0].$el.parents("section.style-guide-toggle");
                if ($p.length) {
                  var $tab = $p.find(".tab:nth-child("+i+")");
                  if ($tab.length) {
                    $tab.parent().find(".active").removeClass("active");
                    //$('.shop-full-look-placeholder.desktop-only').hide('fast');
//                     $tab.addClass("active");
                    //$('.shop-full-look-placeholder.desktop-only').show('fast');
                  }
                }
              },
            },
          }
          }
        }
        else{
          console.log('style guide section here')
          swiper_args = {
            loop: true,
            autoplay: false,
            simulateTouch: false,
            disableOnInteraction: false,
            slidesPerView: 'auto',
            centeredSlides: true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            
          }
        }
          
      } else if ($(this).hasClass("circular-swiper")) {
        swiper_args = {
          loop: false,
          autoplay: false,
          simulateTouch: false,
          slidesPerView: 'auto',
          centeredSlides: false,
          disableOnInteraction: false,
          breakpoints: {
            768: {
              loop: true,
              draggable:true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            },
            640: {
              loop: true,
              draggable:true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            },
            480: {
              loop: true,
              draggable:true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            },
            320: {
              loop: true,
              draggable:true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            }
          }
        }
      } 
      else if ($(this).hasClass("js-image-grid-swiper")) {
        var item_count = $(this).find('.image-grid-with-subtitle-block').length;
        if(item_count>3){
          swiper_args = {
          loop: false,
          initialSlide:0,
          draggable:true,
          autoplay: false,
          simulateTouch: true,
          slidesPerView: 3,
          centeredSlides: false,
          disableOnInteraction: false,
           navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
          breakpoints: {
            768: {
              loop: false,
              draggable:true,
              slidesPerView: 'auto',
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            },
            640: {
              loop: false,
              draggable:true,
              slidesPerView: 'auto',
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            },
            480: {
              loop: false,
              draggable:true,
              slidesPerView: 'auto',
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            },
            320: {
              loop: false,
              draggable:true,
              slidesPerView: 'auto',
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            }
          }
        }  
        }
        else{
          swiper_args = {
          loop: false,
          initialSlide:0,
          autoplay: false,
          simulateTouch: false,
          slidesPerView: 'auto',
          centeredSlides: false,
          disableOnInteraction: false,
          breakpoints: {
            768: {
              loop: false,
              draggable:true,
              slidesPerView: 'auto',
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            },
            640: {
              loop: false,
              draggable:true,
              slidesPerView: 'auto',
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            },
            480: {
              loop: false,
              draggable:true,
              slidesPerView: 'auto',
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            },
            320: {
              loop: false,
              draggable:true,
              slidesPerView: 'auto',
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            }
          }
          }
        }
        
      }
      else if ($(this).hasClass("styling-session__locations")) {
        swiper_args = {
          loop: false,
          autoplay: false,
          simulateTouch: false,
          slidesPerView: 'auto',
          centeredSlides: false,
          disableOnInteraction: false,
          roundLengths: true,
          navigation: {
             nextEl: '.swiper-button-next',
             prevEl: '.swiper-button-prev',
           },
        }
      } else if ($(this).hasClass("featured-products-swiper")) {
        swiper_args = {
          loop: false,
          autoplay: false,
          simulateTouch: false,
          slidesPerView: 'auto',
          centeredSlides: false,
          disableOnInteraction: false,
          roundLengths: true,
        }
      }
	//Homepage featured-prod-swiper
      else if ($(this).hasClass("featured-prod-swiper")) {
        
        swiper_args = {
          loop: false,
          observer: true,
          observeParents: true,
          autoplay: false,
          slidesPerView:4,
          centeredSlides: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            320: {
              slidesPerView: 'auto',
            },
            480: {
              slidesPerView: 'auto',
            },
            640: {
              slidesPerView: 'auto',
            },
            768: {
              slidesPerView: 'auto',
            },
            1024: {
              slidesPerView: 'auto',
            },
          },
          on: {
            slideChange: function () {
              var i = $(this)[0].realIndex + 1;
              var $p = $(this)[0].$el.parents("section.style-guide-toggle");
              if ($p.length) {
                var $tab = $p.find(".tab:nth-child("+i+")");
                if ($tab.length) {
                  $tab.parent().find(".active").removeClass("active");
                  //$('.shop-full-look-placeholder.desktop-only').hide('fast');
                  $tab.addClass("active");
                  //$('.shop-full-look-placeholder.desktop-only').show('fast');
                }
              }
            },
          },
        }
        // console.log(swiper_args,$(this))
      }
      else {
        swiper_args = {
          slidesPerView: 'auto',
          centeredSlides: false,
          roundLengths: true,
          loop: false,
          preventClicks: false,
        }
      }

      // mySwiper.slideTo(index, speed, runCallbacks);

      var $t = $(this);
      // $t.imagesLoaded(function() {
      S.swiper.destroy($t);
//       console.log($t)

      var swiper = new Swiper($t, swiper_args);
      
        /*
        if ($("body").hasClass("body--index")) {
          swiper.autoplay.stop();
          setTimeout(function() {
            swiper.autoplay.start();
          }, S.vars.loaderTime + 1000)
        } */
        $t.removeClass("unloaded");
      // })


    });
  
  
    if (S.isMobile) {
      if($('.split.home-swiper-mobile').length>0){
        var slideauto = {
          delay: 6000,
        };
        var slidepagi = {
          el: '.swiper-pagination',
          clickable: true
        };
        var swiper_args = {
          loop: true,
          autoplay: false,
          simulateTouch: false,
          pagination: slidepagi,
          disableOnInteraction: false,
          slidesPerView: 1,
          centeredSlides: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        }

        var $t = $('.split.home-swiper-mobile');
        // $t.imagesLoaded(function() {
        S.swiper.destroy($t);
        console.log('split slder',$t)
        var swiper = new Swiper($t, swiper_args);
      }
    }
  }

  S.swiper.update = function(swiper) {
    swiper.update();
  }

  S.swiper.onInit = function(swiper) {
    S.swiper.onSlideChangeStart(swiper);
  }

  S.swiper.slideStart = function(swiper) {
    var i = $(".swiper-slide-active").attr("data-swiper-slide-index");
    $(".slide-current").text(i);
  }

  S.swiper.onSlideChangeStart = function(swiper) {
    console.log("::: on slide change start");
    console.log("current index: " + swiper.realIndex);

  }


  S.swiper.destroy = function($t) {
    if ($t.attr("id") == "related") {
      console.log("this is related mode");
      if (S.swiper.relatedSwiper) {
        console.log("found related swiper, destroy it");
        S.swiper.relatedSwiper.destroy();
        delete S.swiper.relatedSwiper;
      }
    }
    $t.find('.swiper-wrapper').removeAttr('style');
    $t.find('.swiper-slide').removeAttr('style');
  }

 
  videoFeature.init();
  // Find youtube and vimeo iframes
  var $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    var ratio = width / height;

    //Determine ratio to be used
    if(Math.abs( ratio - 1 / 1 ) == 0) {
      return '1:1';
    } else {
      return ( Math.abs( ratio - 4 / 3 ) < Math.abs( ratio - 16 / 9 ) ) ? '4:3' : '16:9';
    }
  }

  $videoIframes.each(function(index, iframe) {

    // Update selector
    var $iframe = $(iframe);

    // Grab src
    var source = $iframe.attr('src');

    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap('<div class="lazyframe" data-ratio="'+ getAspectRatio($iframe.attr('width'), $iframe.attr('height'))  +'" data-src="' + source + '"></div>');
    }
  })

  // Initiate lazyframe
  lazyframe('.lazyframe');


  S.scroll = {}
  S.scroll.action = function() {
    var scroll = $(window).scrollTop();
    var $h = $(".header");var $h_wrapper = $(".header-wrapper"), subnav = $('.subnav');

    //     console.log("visible",subnav.hasClass("expanded"))
    if(S.isTablet){
      if (scroll > 36 && !$h.hasClass("header-sticky")) {
        $h_wrapper.addClass('header-sticky');
        $('#page-content').addClass('header-sticky');
        $h.addClass("header--toggled");
      } else if (scroll <= 36){
        $h_wrapper.removeClass('header-sticky');
        $('#page-content').removeClass('header-sticky');
        if(!subnav.hasClass("expanded")){
          $h.removeClass("header--toggled");
        }
      }
    }
    else{
      if (scroll > 20 && !$h.hasClass("header-sticky")) {
        $h_wrapper.addClass('header-sticky');
        $('#page-content').addClass('header-sticky');
        $h.addClass("header--toggled");
      } else if (scroll <= 20){
        $h_wrapper.removeClass('header-sticky');
        $('#page-content').removeClass('header-sticky');
        if(!subnav.hasClass("expanded")){
          $h.removeClass("header--toggled");
        }
      }
    }
  }

  S.scroll.enable = function() {
    bodyScrollLock.clearAllBodyScrollLocks()
    $("body").removeClass("scroll-disabled")
    console.log("scroll enable!")

  }

  S.scroll.disable = function($t) {
    // bodyScrollLock.disableBodyScroll($t);

    bodyScrollLock.disableBodyScroll($t, {
     allowTouchMove: el => {
       while (el && el !== document.body) {
         if (el.getAttribute("body-scroll-lock-ignore") !== null) {
           return true
         }
         el = el.parentNode
       }
     }
   })

   $("body").addClass("scroll-disabled")
//    console.log("scroll disabled!");
   // $("html, body").addClass("disable-scroll-zoom");
  }

  S.share = {}

  S.share.links = function($s) {
    if ($s == null) {
      $s = $("body");
    }

    $s.find('a.share-facebook').click(function(e) {
      e.preventDefault();
      var $t = $(this);
      console.log($t)
      window.open("https://www.facebook.com/sharer/sharer.php?u=" + S.share.url($t),"","width=640, height=320");
    });

    $s.find('a.share-twitter').click(function(e) {
      e.preventDefault();
      var $t = $(this);
      var $p = $t.parent();

      var url = S.share.url($t);
      var len = url.length;

      var via = $t.attr("data-via");
      if (via) {
        len = len +  5 + via.length;
        via = "&via=" + via;
      } else {
        via = '';
      }
      window.open("https://twitter.com/intent/tweet?url=" + url+via,"",'width=640,height=400');

    });


    $s.find("a.share-linkedin").click(function(e) {
      e.preventDefault();
      var $t = $(this);
      window.open("https://www.linkedin.com/shareArticle?mini=true&url=" + S.share.url($t),"",'width=640,height=400');
    })

    $s.find("a.share-pinterest").click(function(e) {
      e.preventDefault();
      $("#pinit-btn [data-pin-href]").trigger("click");
    })
  }

  S.share.url = function($t) {
    if ($t.length && $t.parents(".share").first().attr("data-href")) {
      var url = $t.parents(".share").first().attr("data-href");
      console.log("share url: " + url);
    } else {
      var url = window.location.href;
      console.log("share url backup: " + url);
    }

    return encodeURIComponent(url);
  }


  S.loader = {}
  S.loader.animationData = {"v":"5.6.5","fr":29.9700012207031,"ip":0,"op":67.0000027289659,"w":1920,"h":1080,"nm":"argent loader_option_2","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"argent loader_option_2 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[960,540,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-25.749,-0.004],[-0.001,25.754],[25.754,0.001],[0.001,-25.754],[0,0]],"o":[[25.754,0.001],[0.001,-25.754],[-25.754,-0.001],[0,0],[0.007,25.749]],"v":[[-0.002,46.632],[46.632,0.002],[0.002,-46.632],[-46.632,-0.002],[-46.632,0.008]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[754.133,777.998],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.739,0.739],"y":[1,1]},"o":{"x":[0.79,0.79],"y":[0,0]},"t":15,"s":[0,0]},{"i":{"x":[0.331,0.331],"y":[1,1]},"o":{"x":[0.264,0.264],"y":[0,0]},"t":24.819,"s":[140,140]},{"i":{"x":[0.739,0.739],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"t":33,"s":[100,100]},{"i":{"x":[0.565,0.565],"y":[1,1]},"o":{"x":[0.645,0.645],"y":[0,0]},"t":52.819,"s":[100,100]},{"t":61.0000024845809,"s":[0,0]}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.129,"y":1},"o":{"x":0.449,"y":0},"t":4,"s":[{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-129.844,-284.632],[-129.167,-284.618],[-51.156,-284.618],[-51.821,-284.632]],"c":true}]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0},"t":14.901,"s":[{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-129.844,-284.632],[51.833,284.632],[129.844,284.632],[-51.821,-284.632]],"c":true}]},{"i":{"x":0.674,"y":1},"o":{"x":0.69,"y":0},"t":42.406,"s":[{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-129.844,-284.632],[51.833,284.632],[129.844,284.632],[-51.821,-284.632]],"c":true}]},{"t":52.0000021180034,"s":[{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[52.155,285.368],[51.833,285.375],[129.634,285.375],[129.968,285.368]],"c":true}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":1.887,"ix":1},"e":{"a":0,"k":100,"ix":2},"o":{"a":0,"k":180,"ix":3},"m":2,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[988.434,255.226],"ix":2},"a":{"a":0,"k":[-94.222,-284.774],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":306.000012463636,"st":0,"bm":0}],"markers":[]};
  S.loader.params = {
      container: document.getElementById('lottie'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: S.loader.animationData
  };

  S.loader.init = function() {

    var $pop = $(".loader.argent-loader");
    // console.log("loader length: " + $pop.length);
    if ($pop.length) {
      var cookiename = 'argent_loader_cookie';
      var cookie1 = Cookies.get(cookiename);
      console.log('argent_loader_cookie',cookie1)
      var skipCookie = false;
      if (!cookie1 || skipCookie == true) {
        //no cookie, so set cookie
        Cookies.set(cookiename, 'visited', {
          expires: 1,
          path: '/'
        });


        setTimeout(function() {
          $pop.addClass("active");
          if ($pop.hasClass("alt")) {
            lottie.loadAnimation(S.loader.params);
          }
          // return;

          setTimeout(function() {
            $pop.removeClass("active");
            $pop.remove();
            setTimeout(function() {
              // return
              $("body").removeClass("init");
              S.content.cookieBar();
              setTimeout(function() {
                S.content.emailPop();
              }, 5000)
            }, 200)

          }, S.vars.loaderTime);
        }, 1000)


      } else {
        $("body").removeClass("init");
      }
    }
  }


  S.content = {}

  $(document).on('click','[data-dismiss="modal"]',function(){
    $(".modal").removeClass("active");
    S.scroll.enable();
    $('html').css({overflow: 'auto'});
  })
  S.content.emailPop = function() {
    var $pop = $(".newsletter-pop");
    // console.log("pop length: " + $pop.length);
    if ($pop.length) {
      // console.log("--- list.cookie");
      var cookiename = 'argent_emailpop_cookie';
      var cookie1 = Cookies.get(cookiename);
//       console.log('argent_emailpop_cookie',cookie1)
      var skipCookie = false;
//       console.log("cookie: " + cookie1);
      if (!cookie1 || skipCookie == true) {
        //no cookie, so set cookie
        Cookies.set(cookiename, 'visited', {
          expires: 14,
          path: '/'
        });
        
        $('body').addClass('newsletter-opening');
        $pop.addClass("active").find(".sm-x-close").click(function(e) {
          $(".newsletter-pop").removeClass("active");
          $(".modal").removeClass("active");
          $('body').removeClass('newsletter-opening');
        });
      } else {
        // console.log('cookie found: ' + Cookies.get(cookiename));
      }
    }
  }

  S.content.cookieBar = function() {
    var $pop = $(".cookie-bar");
    // console.log("pop length: " + $pop.length);
    if ($pop.length) {
      // console.log("--- list.cookie");
      var cookiename = 'argent_acceptance_cookie';
      var cookie1 = Cookies.get(cookiename);
//       console.log('argent_acceptance_cookie',cookie1)
      var skipCookie = false;
//       console.log("cookie: " + cookie1);
      if (!cookie1 || skipCookie == true) {
        //no cookie, so set cookie
        Cookies.set(cookiename, 'visited', {
          expires: 30,
          path: '/'
        });

        $(".cookie-bar").addClass("active").find(".sm-x-close").click(function(e) {
          $(".cookie-bar").addClass("closed");
        });
      } else {
        // console.log('cookie found: ' + Cookies.get(cookiename));
      }
    }
  }

  S.content.makeFilterTags = function() {
    var tags = '';
    var $f = $(".filters__body");
    // var url =
    if ($f.length) {
      /*
      $f.find(".filter__item--active[data-url]").each(function() {
        var url = $(this).attr("data-url").replace(/\/$/, "");
        // $f.attr("data-url", url);
      })
      */

      var url = $f.attr("data-url");
      $f.find(".filter__item--active[data-tag]").each(function() {
        tags = tags + '+' + $(this).attr("data-tag");
      })
      $f.find(".filter__item--active[data-sort]").each(function() {
        tags = tags + '?sort_by=' + $(this).attr("data-sort");
      })

//       console.log(tags)
      var $close = $f.find(".close-btn");

//       if (tags == '') {
//         if (!$close.hasClass("hide")) {
//           $close.addClass("hide");
//         }
//       } else {
//         if ($close.hasClass("hide")) {
//           $close.removeClass("hide");
//         }
//       }

      $close.attr("href", url + "/" + tags);
    }

  }



   S.kit = {}

  S.kit.checkSectionErrors = function(name, $kit_pagi) {
    var names = name.split(","), errors = false, results = 0;
    if (names.includes("first_name")) {
      var error_msg = "Please provide all details"
    } else if (names.length > 1) {
      var error_msg = 'Oops, you left out some answers'
    } else {
      var error_msg = 'Please pick at least one answer'
    }

    var error = false;

    for (var a = 0; a < names.length; a++) {
      results = $("#"+names[a]+":checked").length;
      if (results == 0) {
        results = $("#"+names[a]+"[type=hidden]").val() ? 1 : 0
      }
      if (results == 0) {
        results = $("#"+names[a]+"[type=text]").val() ? 1 : 0
      }
      if (results == 0) {
        results = $("select#kit_"+names[a]).val() ? 1 : 0
      }

      if (results == 0) {
        error = true;
        console.log(names[a])
        console.log($("[data-question='"+names[a]+"']").length)
        $("[data-question='"+names[a]+"']").addClass("error");
      }
    }

    if (error == true) {
      $kit_pagi.prepend('<div class="error">'+error_msg+'</div>');
      setTimeout(function() {
        $kit_pagi.find(".error").addClass("inactive");
        setTimeout(function() {
          $("[data-question].error").removeClass("error");
          $kit_pagi.find(".error").remove();
        }, 500)
      }, 2000)
      // return true
    }

    return error
  }

  S.kit.thankyou = function() {
    var $s = $(".starter-kit-body");
    /*
    var html = `<div class="kit-thankyou">
    <h2 class="kit-thankyou-title type-b">Nice Work!</h2>
    <div class="kit-thankyou-text type-c">The welcome kit is on its way to you.</div>
    <a href="/collections/all" class="btn reverse">Keep Shopping</a>
    </div>`
    */
    var html = $("#kit-thankyou-html").html();
    $s.append(html);
    setTimeout(function() {
      $s.addClass("completed")

      setTimeout(function() {
        $(".starter-kit-wrapper").scrollTop(0);
        $s.find(".kit-progress,form,.step-login").remove();
      }, 10)

    }, 1500)

    // $s.find(".kit-progress,form,.step-login").remove();

  }


  S.kit.progress = function(up_device_count) {
    if (!up_device_count) {
      up_device_count = false;
    }
    var $active = $(".kit-survey-step.active"), step = $active.index() + 1, $bar = $(".kit-progress-indicator"), device_step = step;
    if (step > 4 || up_device_count == true) {
      device_step++;
    }
    // console.log("step: " + step);
    // console.log("device-step: " + device_step);
    $(".kit-pages.desktop-only .step").text(step);
    $(".kit-pages.device-only .device-step").text(device_step)
    $bar.attr("data-step", step);
    $bar.attr("data-device-step", device_step);


    $(".starter-kit-wrapper").scrollTop(0);
    var survey = S.kit.makeSurveyAnswers();
    console.log(survey);
  }


  S.kit.pagi = function($s) {
    $s.find(".shopify-section > .kit-survey-step").unwrap();

    $s.find(".x-close,.overlay-blur").click(function(e) {
      e.preventDefault();
      $(".starter-kit-survey").removeClass("active");
      S.scroll.enable() // $("html, body").removeClass("disable-scroll-zoom");
    })

    $s.find(".kit-pagi-prev:not(.kit-pagi-prev-sub)").click(function(e) {
      e.preventDefault();
//       console.log("prev clicked");
      var $active = $(this).parents(".kit-survey-step.active").first(), active = $active.index(), up_device_count = false;
      if (active == 4) {
        // the step after fit
        up_device_count = true
      }

      if (active >= 1) {
        var $next = $(".kit-steps .kit-survey-step:nth-child("+active+")");
//         console.log('next',$next)
        if ($next.length) {
          $active.removeClass("active");
          $next.addClass("active");
          S.kit.progress(up_device_count);
        }
      } else {
        var $next = $(".kit-survey-step.step-login");
        if ($next.length) {
          $active.removeClass("active");
          $next.addClass("active");
        }

      }
    })

    $s.find(".kit-pagi-next:not(.kit-pagi-next-sub)").click(function(e) {
      e.preventDefault();
//       console.log("next clicked");
      // var survey = S.kit.makeSurveyAnswers();
      // console.log(survey);
      // return
      var $active = $(this).parents(".kit-survey-step.active").first(),
      active = $active.index() + 2,
      name = $(this).attr("data-name"),
      $kit_pagi = $active.find(".kit-pagi");
//       console.log($active,$(this))

      if (name) {
        var hasErrors = S.kit.checkSectionErrors(name, $kit_pagi);
        if (hasErrors) {
//           console.log("hasErrors! " + hasErrors )
          return
        }
      }

//       console.log(active,$(".kit-steps .kit-survey-step:nth-child("+active+")"))
      if ($(this).attr("type") == "submit") {
        // do the submission
        // console.log("final submit!");
        // S.kit.thankyou();
        $(".kit-pagi-next[type='submit']").text("Submitting...");
        $("form#starter-kit-form").submit();

      } else {
//         console.log(active)
        if (active <= $(".kit-steps .kit-survey-step").length) {
          var $next = $(".kit-steps .kit-survey-step:nth-child("+active+")");
          if ($next.length) {
            $active.removeClass("active");
            $next.addClass("active");
            S.kit.progress();
          }
        } else {
          // console.log("skipped active!")
        }
      }



    })

    $s.find(".kit-pagi-prev-sub").click(function(e) {
      e.preventDefault();
      var $kit_pagi = $(this).parents(".kit-pagi").first(),
      $section = $(this).parents(".kit-survey-step").first();
      $active = $section.find(".kit-sub-section.active"),
      $next = $section.find(".kit-sub-section:not(.active)"),
      $gobacksub = $(this),
      $goback = $kit_pagi.find(".kit-pagi-prev:not(.kit-pagi-prev-sub)"),
      $nextbtnsub = $kit_pagi.find(".kit-pagi-next.kit-pagi-next-sub"),
      $nextbtn = $kit_pagi.find(".kit-pagi-next:not(.kit-pagi-next-sub)");

      if ($next.length) {
        $active.removeClass("active");
        $next.addClass("active");

        // hide the actual next button and make the sub one active
        $nextbtnsub.removeClass("device-inactive");
        $nextbtn.addClass("device-inactive");

        // hide the sub go back button and show actual go back button
        $gobacksub.addClass("device-inactive");
        $goback.removeClass("device-inactive");

        S.kit.progress(); // adjust progress bar
      }

    })

    $s.find(".kit-pagi-next-sub").click(function(e) {
      e.preventDefault();
      // this is for the device version where this section is two pages in device
      // this button is in the first sub-section of the section, clicking it will take you to the second sub-section

      var $kit_pagi = $(this).parents(".kit-pagi").first(),
      $section = $(this).parents(".kit-survey-step").first();
      $active = $section.find(".kit-sub-section.active"),
      $next = $section.find(".kit-sub-section:not(.active)"),
      name = $(this).attr("data-name")
      $gobacksub = $kit_pagi.find(".kit-pagi-prev-sub"),
      $goback = $kit_pagi.find(".kit-pagi-prev:not(.kit-pagi-prev-sub)"),
      $nextbtnsub = $(this),
      $nextbtn = $kit_pagi.find(".kit-pagi-next:not(.kit-pagi-next-sub)");

      var hasErrors = S.kit.checkSectionErrors(name, $kit_pagi);
      if (hasErrors) {
        return
      }

      if ($next.length) {
        $active.removeClass("active");
        $next.addClass("active");

        // hide the sub next button and make the actual one active
        $nextbtnsub.addClass("device-inactive");
        $nextbtn.removeClass("device-inactive");

        // hide the actual go back button and show the sub go back button that takes you back to the first sub section
        $gobacksub.removeClass("device-inactive");
        $goback.addClass("device-inactive");

        S.kit.progress(true); // up device count
      }
    })


    $s.find("button.kit-guest-continue").click(function(e) {
      e.preventDefault();
      var $e = $("#kit-email"), $ep = $(".field.kit-email");
      var email = $e.val();
      if (!email) {
        $e.addClass("error");
        return
      }
      console.log("try to update name email!")
      $("form#starter-kit-form input[name='email']#kit_email").val(email);
      var $next = $(".kit-steps .kit-survey-step:nth-child(1)");
      if ($next.length) {
        $(".kit-survey-step.step-login.active").removeClass("active");
        $next.addClass("active");
        S.kit.progress();
      }
    })


    /*
    $("#kit_height_ft,#kit_height_in").change(function() {
      var ft = $("#kit_height_ft").val();
      var inches = $("#kit_height_in").val();
      var calculatedHeight = ft + "' " + inches + '"';
      $("#height").val(calculatedHeight);
    }) */

    $s.find(".kit-answers-select").each(function() {
      $(this).find(".answer-trigger").click(function(e) {
        e.preventDefault();
        var $t = $(this).siblings(".fields").first();
        if ($t.hasClass("active")) {
          $t.removeClass("active");
          $(this).removeClass("active");
        } else {
          $t.addClass("active");
          $(".kit-answers-select .answer-trigger.active").trigger("click"); // close other actives
          $(this).addClass("active");
        }
      })

      $(this).find(".answer-input").click(function() {
        var $p = $(this).parents(".answer-select-block").first();
        val = $(this).val();
        $p.find(".selected-answer").text(val);
        if ($(this).attr("name") == "height_in" || $(this).attr("name") == "height_ft") {
          var ft = $("input[name='height_ft']:checked").val();
          if (ft) {
            var inches = $("input[name='height_in']:checked").val();
            if (!inches) {
              inches = 0;
            }
            var calculatedHeight = ft + "' " + inches + '"';
            $("#height").val(calculatedHeight);
          }

        }
        $p.find(".answer-trigger").trigger("click");
      })
    })

    $s.find("input[required]").focus(function() {
      $(this).removeClass("error");
      //$(this).parents(".field.error").first().removeClass("error");
    })

  }

  S.kit.getCheckboxValues = function(id) {
    var checkboxes = document.getElementsByName(id);
    var vals = "";
    var question = checkboxes[0].dataset.question;
    for (var i=0, n=checkboxes.length;i<n;i++)
    {
        if (checkboxes[i].checked)
        {
            vals += ", "+checkboxes[i].value;
        }
    }
    if (vals) vals = vals.substring(2)
    else vals = ' - ';

    return { q: question, a: vals }
  }

  S.kit.getRadioValue = function(id) {
    var checkboxes = document.getElementsByName(id);
    var question = checkboxes[0].dataset.question;
    var vals = "";
    for (var i=0, n=checkboxes.length;i<n;i++)
    {
        if (checkboxes[i].checked)
        {
            val = checkboxes[i].value;
            return { q: question, a: val }
        }
    }

    return { q: question, a: " - " }

  }

  S.kit.getTextValue = function(id) {
    var text = document.getElementsByName(id)[0];
//     console.log(text);
    var question = text.dataset.question;
    var val = text.value
    if (val) {
      return { q: question, a: val }
    }
    return { q: question, a: " - " }
  }

  S.kit.makeSurveyAnswers = function() {
    // e.target is the same as our form
    var images = [];
    var occasion = S.kit.getCheckboxValues("occasion[]");
    var style = S.kit.getCheckboxValues("style[]");
    var need = S.kit.getCheckboxValues("need[]");
    var colors = S.kit.getCheckboxValues("colors[]");
    var fit = S.kit.getCheckboxValues("fit[]");
    var tops_size = S.kit.getRadioValue("tops_size");
    var bottom_size = S.kit.getRadioValue("bottom_size");
    var arms = S.kit.getRadioValue("arms");
    var shoulders = S.kit.getRadioValue("shoulders");
    var torso = S.kit.getRadioValue("torso");
    var legs = S.kit.getRadioValue("legs");
    var shape = S.kit.getRadioValue("shape");
    var tone = S.kit.getRadioValue("tone");
    var height = S.kit.getTextValue("height");
    var free_response = S.kit.getTextValue("free_response");
// 	console.log(free_response)
    var survey = [
      {
        name: occasion.q,
        value: occasion.a,
      },
      {
        name: style.q,
        value: style.a,
      },
      {
        name: need.q,
        value: need.a,
      },
      {
        name: colors.q,
        value: colors.a,
      },
      {
        name: fit.q,
        value: fit.a,
      },
      {
        name: tops_size.q,
        value: tops_size.a,
      },
      {
        name: bottom_size.q,
        value: bottom_size.a,
      },
      {
        name: height.q,
        value: height.a
      },
      {
        name: arms.q,
        value: arms.a,
      },
      {
        name: shoulders.q,
        value: shoulders.a,
      },
      {
        name: torso.q,
        value: torso.a,
      },
      {
        name: legs.q,
        value: legs.a,
      },
      {
        name: shape.q,
        value: shape.a,
      },
      {
        name: tone.q,
        value: tone.a,
      },
      {
        name: 'Free Response',
        value: free_response.a,
      },
      ...images.map((url, i) => ({
        name: `Image ${i + 1}`,
        value: images[i],
      }))
    ]

    return survey
  }

  S.kit.init = function(el) {

    if (!el.hasClass("logged-in") && window.location.href.indexOf("checkout_url") == -1) {
      window.history.pushState( {} , '', '/pages/starter-kit?checkout_url=/pages/starter-kit' );
    }

    new Shopify.CountryProvinceSelector('kit_country', 'kit_state', {hideElement: 'kit_state'});
    // var defaultState = $('.province-select[data-default]').attr("data-default"); $('.province-select > option').each(function(){ if ('[value]' == defaultState){ $(this).attr('selected', 'selected'); } });
//     console.log($("#kit_state option"))
    $("#kit_state option[value='Alaska']").remove();
    $("#kit_state option[value='Hawaii']").remove()
    $("#kit_state option[value='American Samoa']").remove();
    $("#kit_state option[value='Guam']").remove();
    $("#kit_state option[value='Northern Mariana Islands']").remove();
    $("#kit_state option[value='Puerto Rico']").remove();
    $("#kit_state option[value='Virgin Islands']").remove();
    setTimeout(function() {
      $('.province-select[data-default]').each(function() {
        var defaultState = $(this).attr("data-default");
        if (defaultState != "State") {
          $(this).val(defaultState);
        }

      })
    }, 500)

    if (!$(".step-login").length) {
      S.kit.progress(el);
    }

    S.kit.pagi(el);
    S.kit.form(el);


    $(".kit-video").each(function() {
      var $video = document.getElementById("kitvideo");
      $(this).find(".video-control").click(function(e) {
        var $video = document.getElementById("kitvideo");
        if ($(this).hasClass("playing")) {
          $video.pause();
          $(this).removeClass("playing");
        } else {
          $(this).addClass("playing");
          $video.play();
        }
      })
    })




    $("a[href='#start']").click(function(e) {
      e.preventDefault();
      $(".starter-kit-survey").addClass("active");
      S.scroll.disable($(".starter-kit-survey [body-scroll-lock-ignore]"));
    })

    // this has to be done BEFORE the checkout_url is added
    // console.log("document.referrer: " + document.referrer)
    var hash = window.location.hash;
    if (hash == "#start" || document.referrer.indexOf("oxiapps.com") > -1 || document.referrer.indexOf("social-login") > -1) {
      S.scroll.disable(el.find("[body-scroll-lock-ignore]"));
      el.addClass("active");
    }
  }

  S.kit.form = function(el) {
    // S.kit.thankyou();


    // e.g. https://gifted-allen-c9825f.netlify.app
    var NETLIFY_URL = 'https://silly-ptolemy-de369c.netlify.app';
    // var NETLIFY_URL  = 'https://gifted-allen-c9825f.netlify.app';
    // You can make track state like in React, but you'll have to manually update the nodes.
    let processing = true;
    let images = [];

    /*

    if (window.location.hash == "#test") {
      console.log(window.location.hash )
      setTimeout(function() {
        S.kit.thankyou();
      }, 6000)

    } */



    // this is a test for get-order
    /*
    if (window.location.hash == "#test") {
      console.log("get order test");
      fetch(`${NETLIFY_URL}/.netlify/functions/create-final-order`, {
        method: "POST",
        // body: "",
        // If you want the user to type their email before reaching Braintree,
        // you can specify the email here. This will load up their previous payment methoods.
        body: JSON.stringify({ order_id: "2340616634505" }),
      }).then((r) => r.json())
      .then(({ order }) => {
        // Initialize Braintree
        console.log(order)
      });
    }
    */

    /*
    if (window.location.hash == "#test") {
      console.log("get order test");
      try {
        fetch(`${NETLIFY_URL}/.netlify/functions/update-final-order`, {
          method: "POST",
          // body: "",
          // If you want the user to type their email before reaching Braintree,
          // you can specify the email here. This will load up their previous payment methoods.
          body: JSON.stringify({ order_id: "2351997157513" }),
        }).then((r) => r.json())
        .then(({ order }) => {
          // Initialize Braintree
          console.log(order)
        });
      } catch (err) {
        console.log(err)
        // throw new Error("Invalid order_id");
      }

    } */




    // return



    let braintreeInstance;
    let deviceData;



    // Braintree needs a server-generated token
    fetch(`${NETLIFY_URL}/.netlify/functions/client-token`, {
      method: "POST",
      body: "",
      // If you want the user to type their email before reaching Braintree,
      // you can specify the email here. This will load up their previous payment methoods.
      // body: JSON.stringify({ email: "janedoe@gmail.com" }),
    })
      .then((r) => r.json())
      .then(({ clientToken }) => {
        // Initialize Braintree
        window.braintree.dropin.create(
          {
            authorization: clientToken,
            container: document.querySelector("#dropin-container"),
            dataCollector: {
              kount: false
            }
          },
          function (createErr, instance) {
            braintreeInstance = instance;
            deviceData = instance._dataCollector._instance.deviceData;
          }
        );
      });



    // Cloudinary


    var widget = cloudinary.createUploadWidget({
      cloudName: "argentwork",
      uploadPreset: "vtw7id6z",
      resourceType: 'image',
      singleUploadAutoClose: true,
      maxFiles: 1,
      inlineContainer: "#kit-photo-uploader"
    }, (err, result) => {
      if (!err && result && result.event === "success") {
        images = [...images, result.info.secure_url];
        // console.log("success!")
        // console.log(images)
      } else {
        // console.log(err)
      }
    });

    var openWidget = (file) => {
    //   console.log("openWidget!")
      // console.log(file)
      images = [];
      widget.open(null, {files: [file]});
    }

    var uploadButton = el.find('.UploadButton');
    uploadButton.click(function(e) {
      images = [];
      widget.open();
    })
    
    $(".free_response").each(function() {
      $(this).on("change keyup", function(e){
        var $val = $(this).val();
        if ($val != null && $val.length > 0 ) {
          $(".step-free-response .kit-pagi-next").text("Next Step");

        } else {
          $(".step-free-response .kit-pagi-next").text("Skip Step");
        }
      });
    })

    $("input[type=file].kit-photo-upload").each(function() {
      $(this).on("change", function(e){
        if ($(this)[0].files && $(this)[0].files.length > 0 ) {
            var reader = new FileReader();
            reader.onload = function (e) {
              $('.kit-photo-circle').addClass("uploaded").css("backgroundImage", 'url(' + e.target.result + ')')
            };

            reader.readAsDataURL($(this)[0].files[0]);
            $(".step-photo .kit-pagi-next").text("Next Step");
            // move the actual upload to form submission handler?
            openWidget($(this)[0].files[0])

        } else {
          $('.kit-photo-circle').removeClass("uploaded").css("backgroundImage", "");
          $(".step-photo .kit-pagi-next").text("Skip Step");
          // $(this).siblings(".filename").remove();
        }
      });
    })

    //return;







    // Form submission
    var handleSubmit = (e) => {
      e.preventDefault();
      $("[data-braintree-id=toggle]").removeClass("active");


      var survey = S.kit.makeSurveyAnswers()


      // console.log(...images);
      // return;

      var inputs = e.target.elements;
//       console.log(inputs);


      const surveyObject = Object.fromEntries(
        new Map(survey.map(x => ([x.name, x.value])))
      );

      // surveyObject["Starter Kit RMA"] = false

      // console.log(surveyObject);


      // console.log(_learnq);

      /*
      if (window.location.hash == "#test") {
        S.kit.thankyou();
        return
      } */

      /*
      const payload = {
        email: inputs.kit_email.value,
        first_name: inputs.first_name.value,
        last_name: inputs.last_name.value,
        address1: inputs.address1.value,
        address2: inputs.address2value,
        city: inputs.city.value,
        state: inputs.kit_state.value,
        zip: inputs.zip.value,
        country: inputs.kit_country.value,
        // phone: inputs.phone.value,
        survey: survey
      };

      console.log(payload)

      return */



      return braintreeInstance.requestPaymentMethod().then((paymentMethod) => {
        console.log(paymentMethod);
        const token = paymentMethod.nonce;
        const paymentCardType = paymentMethod.details.cardType;
        const paymentEnding = paymentMethod.details.lastFour;
        const deviceData = paymentMethod.deviceData;

        console.log(`Created token ${token}`);

        // S.kit.thankyou();


        /*
        // moved to later, only on successful submission
        _learnq.push(['identify', {
        '$email' : inputs.email.value,
        ...surveyObject
        }]);

        _learnq.push(['track', 'Starter Kit Submitted', surveyObject]);
        */

        // console.log(deviceData)



        const payload = {
          token,
          email: inputs.kit_email.value,
          first_name: inputs.first_name.value,
          last_name: inputs.last_name.value,
          address1: inputs.address1.value,
          address2: inputs.address2.value,
          city: inputs.city.value,
          state: inputs.kit_state.value,
          zip: inputs.zip.value,
          country: inputs.kit_country.value,
          // phone: inputs.phone.value,
          survey: survey,
          paymentMethod: paymentCardType,
          paymentEnding: paymentEnding,
          deviceData: deviceData
        };


        console.log("Sending to Netlify function...", payload);
        // return


        return fetch(`${NETLIFY_URL}/.netlify/functions/create-kit-order`, {
          method: "POST",
          body: JSON.stringify(payload),
        })
        .then((res) => {
          return res.json().then((data) => {
            if (res.status === 200) {
              console.log("Created draft order", data);
              processing = false;
              S.kit.thankyou();
              
//               _learnq.push(['identify', {
//                 '$email' : inputs.kit_email.value,
//                 ...surveyObject
//               }]);

//               _learnq.push(['track', 'Starter Kit Submitted', surveyObject]);

            } else {
              console.error(data);
              var err_msg = "Could not submit.";
              var err = data;

              /*
              if (err.verification) {
                if (err.verification.cvvResponseCode == "N" && err.verification.avsPostalCodeResponseCode == "N") {
                  err_msg = "Invalid CVV and Zipcode."
                } else if (err.verification.cvvResponseCode == "N") {
                  err_msg = "Invalid CVV."
                } else if (err.verification.avsPostalCodeResponseCode == "N") {
                  err_msg = "Invalid Zipcode."
                }
              } */
              $(".kit-pagi .error").remove();
              $(".kit-pagi-next[type='submit']").before('<div class="error">'+err_msg+'</div>');
              $("[data-braintree-id=toggle]").addClass("active");
              setTimeout(function() {
                $(".kit-pagi .error").remove();
                $(".kit-pagi-next[type='submit']").text("Finish Quiz");
              }, 2000);
            }
          });
        })
        .catch((err) => {
          processing = false;
          console.error(err);
          var err_msg = "Credit card could not be verified.";

          if (err.verification) {
            if (err.verification.cvvResponseCode == "N" && err.verification.avsPostalCodeResponseCode == "N") {
              err_msg = "Invalid CVV and Zipcode."
            } else if (err.verification.cvvResponseCode == "N") {
              err_msg = "Invalid CVV."
            } else if (err.verification.avsPostalCodeResponseCode == "N") {
              err_msg = "Invalid Zipcode."
            }
          }
          $(".kit-pagi .error").remove();
          $(".kit-pagi-next[type='submit']").before('<div class="error">'+err_msg+'</div>');
          $("[data-braintree-id=toggle]").addClass("active");
          setTimeout(function() {
            $(".kit-pagi .error").remove();
            $(".kit-pagi-next[type='submit']").text("Finish Quiz");
          }, 2000);
        });
      }).catch((err) => {
        processing = false;
        console.error(err);
        $(".kit-pagi-next[type='submit']").text('Finish Quiz');
      });

    };

    var form = el.find('form#starter-kit-form');
    form.submit(function(e) {
      handleSubmit(e);
    })


  }
  S.content.init = function($c) {
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    $(".swiper-container .full-looks").each(function() {
      $("body").append($(this));
      // has to happen before swiper init so that there are no duplicates
      // this is for homepage only
    })

    $(".shopify-section").each(function() {
      var html = $(this).html().trim();
      if (html == "") {
        $(this).remove();
      }
    })

    if ($("body").hasClass("body--customers__login") && window.location.href.indexOf("checkout_url") > -1 && window.location.href.indexOf("starter-kit") > -1) {
      window.location.href = "/pages/starter-kit#start"
    }

    if ($(".starter-kit-survey").length) {
      S.kit.init($(".starter-kit-survey"));
    }

//     if (pn && pn.settings.tagSettings) {
//       $("[data-preorder-tag]").each(function() {
//         var id = $(this).attr("data-preorder-tag");
//         var result = pn.settings.tagSettings.filter(p => p.tag == id);
//         if (result && result.length) {
//           if ($(this).hasClass("cart-item__title")) {
//             $(this).after('<span class="preorder-label">Back order</span>')
//           } else {
//             $(this).before('<span class="preorder-label">Back order</span>')
//           }

//           if ($(this).siblings(".sizes-and-btn").find("button.quickshop-mode").length) {
//             $(this).siblings(".sizes-and-btn").find("button.quickshop-mode").text("Back order");
//           }
//         }
//       })
//       // console.log(pn.settings.singleProductSettings);
//     }

//     if (pn && pn.settings.singleProductSettings) {
//       $("[data-preorder-id]").each(function() {
//         var id = $(this).attr("data-preorder-id");
//         var result = pn.settings.singleProductSettings.filter(p => p.n == id);
//         if (result && result.length) {
//           $(this).after('<span class="cart-item__preorder">Back order</span>')
//         }
//       })
//       $("[data-preorder-pid]").each(function() {
//         var id = $(this).attr("data-preorder-pid");
//         var result = pn.settings.singleProductSettings.filter(p => p.p == id);
//         if (result && result.length) {
//           console.log("id: " + result.length);
//           $(this).before('<span class="preorder-label">Back order</span>')
//           if ($(this).siblings(".sizes-and-btn").find("button[type=submit]").length) {
//             $(this).siblings(".sizes-and-btn").find("button[type=submit]").text("Back order");
//           }
//         }
//       })
//       console.log(pn.settings.singleProductSettings);
//     }
    
    
    $("[data-product-preorder]").each(function() {
      var parent = $(this).attr("data-product-preorder");
//       console.log($(this))
      $(this).parents('.product-item__info').find('.preorder-label').remove();
      $(this).parents('.product-item__info').find('.col-two-wrapper .preorder_gone_wrap').append('<span class="preorder-label product-banner product-banner">'+window.theme.preorder_label+'</span>')
      if ($(this).siblings(".sizes-and-btn").find("button[type=submit]").length) {
        $(this).siblings(".sizes-and-btn").find("button[type=submit]").text(window.theme.preorder_btn_label);
      }
    })


    
    
    window.prod_block_preorder_init();
    
    $("[data-product-color-preorder]").on('click',function(e) {
      var preorder = $(this).attr("data-product-color-preorder");
      var pid = parseFloat($(this).attr('data-product-id'));
      var color_name = $(this).find('input').attr('data-option-value');
      var product_id = $(this).find('input').attr('data-product-id');      
      var product_available = $.parseJSON($(this).find('input').attr('data-product-available').toLowerCase());
//       console.log('product_available: ',product_available)
      var variant_json = $.parseJSON($(this).find('input').attr('data-variant-dict'));
//       console.log(variant_json)
      var almost_gone = JSON.parse($(this).parents('.colorway-color-label').attr('data-almost-gone'));
      $(this).parents('[data-product-id]').attr('data-product-id',pid)
      var l = '<span class="preorder-label product-banner">'+window.theme.preorder_label+'</span>';
//       console.log(almost_gone)
      $(this).parents('.product-item__info').find('.preorder-label').remove();
      if(preorder==true || preorder == 'true'){
//         console.log($(this).parents('.product-item__info').find('.product-banner--almost-gone'))
        if($(this).parents('.product-item__info').find('.product-banner--almost-gone').length>0){
          $(this).parents('.product-item__info').find('.product-banner--almost-gone').hide();
        }  
        $(this).parents('.product-item__info').find('.col-two-wrapper .preorder_gone_wrap').append(l);
        // console.log($(this).parents('.product-item__info').find('.col-two-wrapper'))
        // $(this).parents('.product-item__info').find('.color-label-wrapper').after(l);
        if ($(this).parents('.product-item__info').find('.sizes-and-btn').find("button[type=submit]").length) {
          $(this).parents('.product-item__info').find('.sizes-and-btn').find("button[type=submit]").text(window.theme.preorder_btn_label);
        }
      }
      else{

        if(product_available == false){
//           console.log(product_available,$(this).parents('.product-item__info').find('.product-banner--out-of-stock'))
          //Show OOS label and hide Almost Gone
          $(this).parents('.product-item__info').find('.product-banner--almost-gone').attr("style", "display: none !important");
          $(this).parents('.product-item__info').find('.product-banner--out-of-stock[data-option-value !="'+color_name+'"]').attr("style", "display: none !important");
          if($(this).parents('.product-item__info').find('.product-banner--out-of-stock').length>0){
            
            $(this).parents('.product-item__info').find('.product-banner--out-of-stock[data-option-value ="'+color_name+'"]').attr("style", "display: block !important");
          }
          else{
            //           console.log(almost_gone)
            $(this).parents('.product-item__info').find('.product-banner--almost-gone[data-option-value !="'+color_name+'"][data-product-id!='+product_id+']').attr("style", "display: none !important");
          }
          if ($(this).parents('.product-item__info').find('.sizes-and-btn').find("button[type=submit]").length) {
            $(this).parents('.product-item__info').find('.sizes-and-btn').find("button[type=submit]").text('Out of Stock').attr('disabled','disabled');
          }
        }
        else{
          if ($(this).parents('.product-item__info').find('.sizes-and-btn').find("button[type=submit]").length) {
            $(this).parents('.product-item__info').find('.sizes-and-btn').find("button[type=submit]").text('Add to Bag').removeAttr('disabled');
          }
          $(this).parents('.product-item__info').find('.product-banner--out-of-stock').hide();
//           hide OOS label and show Almost Gone
          $(this).parents('.product-item__info').find('.product-banner--almost-gone').attr("style", "display: none !important");
          if($(this).parents('.product-item__info').find('.product-banner--almost-gone').length>0 && almost_gone==true){
            console.log($(this),product_id)
            $(this).parents('.product-item__info').find('.product-banner--almost-gone[data-option-value ="'+color_name+'"][data-product-id='+product_id+']').attr("style", "display: block !important");
          }
          else{
            //           console.log(almost_gone)
            $(this).parents('.product-item__info').find('.product-banner--almost-gone[data-option-value !="'+color_name+'"][data-product-id!='+product_id+']').attr("style", "display: none !important");
          }
        }
        
        
        
//         if ($(this).parents('.product-item__info').find('.sizes-and-btn').find("button[type=submit]").length) {
//           $(this).parents('.product-item__info').find('.sizes-and-btn').find("button[type=submit]").text('Add to Bag');
//         }
      }
      
    })



    S.swiper.init($c);

    S.share.links($c);

    if ($("section.hero").length && (!$('body').hasClass('body--page-about') && !$('body').hasClass('body--page-locations'))) {
      if($("section.hero").hasClass('js-page-work-friends-landing-enable_bgcolor-true') || $("section.hero").hasClass('js-page-content-landing-enable_bgcolor-true')
        || $('section.hero').hasClass('js-page-officehours-landing-enable_bgcolor-true')|| $('section.hero').attr('class').indexOf('enable_bgcolor-true')>-1){
        $(".header").removeClass("reverse no-mobile-reverse");
      }
      else{
        $(".header").addClass("reverse no-mobile-reverse");
      }
//       $(".header").addClass("reverse no-mobile-reverse");
    }
    else if ($(".page-account").length || $('body').attr('class').indexOf('account')>-1) {
      $(".header").removeClass("reverse no-mobile-reverse");
    }
    $("body").on('click','.selected-size',function(e) {
      var this_ele = $(this);
      
      e.preventDefault();
      if(String(this_ele.text()).indexOf('Select ')== -1){
        this_ele.removeClass('error');
      }
      var $t = $(this).siblings(".option__values").first();
      if ($t.hasClass("active")) {
        $t.removeClass("active");
        $(this).removeClass("active");
      } else {
        $t.addClass("active");
        $(this).addClass("active");
      }
    })


    $('body').on("click",'.option-value .option__input',function() {
      
      var $p = $(this).parents(".option");
      var $t = $p.find(".selected-val");
//       console.log($(this).parents('.quickshop-product-content').attr('data-variant-dict'))
//       var variant_json = ($(this).parents('.quickshop-product-content').attr('data-variant-dict')!=undefined)?$.parseJSON($(this).parents('.quickshop-product-content').attr('data-variant-dict')):[];
      var variant_json = $.parseJSON($(this).parents('[data-variant-dict]').attr('data-variant-dict'));
      var prod_title = ($(this).parents('[data-variant-dict]').attr('data-product-title'));
      var prod_id = parseFloat($(this).parents('[data-variant-dict]').attr('data-product-id'));
      // console.log(variant_json);
      $(this).parent(".option-value").addClass("active").siblings(".active").removeClass("active");

      var $n = $p.find(".option-name-click,.selected-size.active");
      var val = $(this).attr("value");
//       console.log($n);
      
     
      var selected_var = $.grep(variant_json, function( n, l ) {
        return (n.option1==val);
      });
     
      // $n.text(val);
      if ($t.length) {
        $t.text(val);
        $t.attr('data-selected',true);
//        console.log('1963',$t)
        if ($t.hasClass("active")) {
          $t.trigger("click");
        }
      }

      var var_qty = (selected_var.length)?selected_var[0].inventory_quantity:1;
      // console.log(selected_var)
      if(var_qty <= window.theme.low_inventory_tag_threshold && var_qty>0){
//         console.log($t.parents('.selected-size'),var_qty)
//         $t.parents('.selected-size').append('<span class="inventory_left type-e">Only '+var_qty+' left</span>');	
      }
      else{
//       console.log('removing qty label')
      }

      if ($n.length) {
        if ($n.hasClass("active")) {
          $n.trigger("click");
        }
      }

      if($t.hasClass('error')){
        $t.attr('data-selected',true);
        $t.removeClass('error')
      }
        
        
//       console.log(selected_var,$n,$t)
//      
      var $trigger = $(this).parents("form").find(".quick-add__button[data-size='"+val+"']");
//       console.log('quick_add');
//             console.log($trigger);

      if ($trigger.length) {
        var preorder_tag2 = [];
        $.each(getDistinct(window.variant_metadata),function(i,n){
          if((n.id==prod_id && n.title ==prod_title ) && n.preorder_enable == "true" && n.entire_product==true){
            preorder_tag2.push(n);
          }
          else if(selected_var.length > 0){
            if(selected_var[0].options_with_values != undefined){
              if(n.option1==selected_var[0].options_with_values[0].value && n.preorder_enable == "true" && n.id==selected_var[0].id){
                preorder_tag2.push(n);
              }
            }
            else if(n.option1==selected_var[0].option1 && n.preorder_enable == "true" && n.id==selected_var[0].id){
              preorder_tag2.push(n);
            }
          }
        })
//         if (parseInt($trigger.attr("data-available")) <= 0) {
//           $(this).parents("form").first().find("button.quickshop-hover-add").text(window.theme.preorder_btn_label);
//         } else {
//           $(this).parents("form").first().find("button.quickshop-hover-add").text('Add to Bag');
//         }

        console.log(preorder_tag2)
        $(this).parents('form').first().find('.product-banner').remove();
        if(preorder_tag2.length>0){
          var preorder_label = '<div class="product-banner preorder-label product-banner--warning product-banner--almost-gone" style="text-align: right;width: 100%;">'+window.theme.preorder_label+'</div>';
//           console.log($(this).parents('form').first().find('.color-labels'))
          $(this).parents('form').first().find('.col-two-wrapper .preorder_gone_wrap').append(preorder_label);
          $(this).parents("form").first().find("button.quickshop-hover-add").text(window.theme.preorder_btn_label);
        } else {
          $(this).parents("form").first().find("button.quickshop-hover-add").text('Add to Bag');
        }
        
      }

    })

    if ($(".page-login").length) {
//       console.log("hash: " + window.location.hash)
      if (window.location.hash == "#forgot") {
        $(".login-form").removeClass("show");
        $(".reset-password-form").addClass("show");
      }
    }


    $(".expandable-title").click(function(e) {
      e.preventDefault();
      var $t = $(this).parents(".expandable-text");
      if ($t.hasClass("active")) {
        $t.removeClass("active");
      } else {
        $t.siblings(".expandable-text.active").removeClass("active");
        $t.addClass("active");
      }
    })

    $(".sizeguide-tab").click(function(e) {
      e.preventDefault();
      var id = $(this).attr("data-id");
      var $p = $(this).parents(".sizeguide-section__sizecharts").find(".size-chart--" + id);
      if ($p.length) {
        if (!$(this).hasClass("active")) {
          $(this).addClass("active").siblings(".active").removeClass("active");
          $p.addClass("active").siblings(".active").removeClass("active");
        }
      }
    })

    $(".sizeguide-tab").first().trigger("click");

    if ($(".contact.support-page").length) {
      $(".support-tab[href='/pages/contact']").addClass("active");
    }

    $("[data-toggle=modal]").click(function(e) {
      e.preventDefault();
      var target = $(this).attr("data-target");
      var $t = $(target);
      S.scroll.disable($t.find("[body-scroll-lock-ignore]"));
      if ($t.length) {
        $t.addClass("active");
        if ($(".modal-resurva").hasClass("active")) {
          $("html, body").addClass("disable-scroll-notfixed");
        }
      }
    })

    $(".modal").each(function() {
      $(this).find(".overlay-blur,.x-close").click(function(e) {
        e.preventDefault();
        S.scroll.enable() // $("html, body").removeClass("disable-scroll-zoom");
        $(this).parents(".modal").removeClass("active show");
        if (!$(".modal-resurva").hasClass("active")) {
          $("html, body").removeClass("disable-scroll-notfixed");
        }
      })
    })

    $("#reviews").each(function() {
      var $t = $(this);
      var c = setInterval(function() {
        var $btn = $t.find(".spr-summary-actions-newreview");
        var $h = $(".product-header-wrapper");
        var $badge = $h.find(".spr-badge");
        var plugincontent = $("#shopify-product-reviews .spr-summary");
        var $rh = $(".reviews-header");

        if ($btn.length && $badge.length && plugincontent) {
          // loaded
          clearInterval(c);
          var o = $("#shopify-product-reviews");
          var n = o.find(".spr-summary");


          $rh.find(".reviews-header__section").first().append(n);
          var i = $rh.find(".spr-summary-actions");
          $rh.find(".reviews-header__section").last().append(i);

          setTimeout(function() {

            if ($badge.find(".spr-badge-starrating").length) {
              // reviews exist
              $badge.find(".spr-badge-caption").addClass("accent-hover").click(function(e) {
                var top = $("#reviews").offset().top - S.size.header;
                window.scrollTo({
                  top: top,
                  behavior: 'smooth'
                });
              })
            }


            $(".spr-summary-actions-newreview").click(function(e) {
              e.preventDefault();
              var $p = $(this).parents(".reviews-section").first().find(".spr-form");
              S.scroll.disable($p.find("[body-scroll-lock-ignore]"));


              if (!$p.find(".overlay-blur").length) {
                $p.prepend('<button class="overlay-blur skip-btn-style"><span class="displace">Close</span></button>');
                $p.find(".new-review-form").prepend('<button class="sm-x-close skip-btn-style"><span class="displace">Close</span></button>');
                $p.find(".overlay-blur,.sm-x-close").click(function(e) {
                  $(".modal").removeClass("active");
                  e.preventDefault();
                  var $p = $(this).parents(".spr-form").first();
                  S.scroll.enable() // $("html, body").removeClass("disable-scroll-zoom");
                  $p.hide().removeClass("active");
                })
              }

              if (!$p.hasClass("active")) {
                $p.addClass("active").show();
              }
            });



            if ($badge.attr("data-rating") == "0.0") {
              $t.addClass("no-reviews hide");

              $h.find(".spr-starrating").remove();
              $h.find(".spr-badge-caption").html('<button class="link-btn skip-btn-style write-review">Write a Review</button>');
              var $btn2 = $h.find("button.write-review");
              $btn2.click(function(e) {
                $btn.trigger("click");
              })
            }

            $t.find(".spr-review-content-body").each(function() {
              if ($(this).text().length > 120) {
                $(this).after('<button class="skip-btn-style read-more type-e link-btn">Read More</button>');
              }
            })

            $t.find("button.read-more").click(function(e) {
              e.preventDefault();
              var $p = $(this).parents(".spr-review-content").first();
              if ($p.hasClass("expanded")) {
                $p.removeClass("expanded");
                $(this).text('Read More');
              } else {
                $p.addClass("expanded");
                $(this).text('Show Less')
              }
            })

            $t.find(".spr-reviews").after('<button class="outline read-all-reviews">Read All Reviews</button>');
            $t.find("button.read-all-reviews").click(function(e) {
              e.preventDefault();
              var $p = $(this).siblings(".spr-reviews");

              if ($p.hasClass("expanded")) {
                $p.removeClass("expanded");
                $(this).text('Read All Reviews');
              } else {
                $p.addClass("expanded");
                $(this).text('Show Less Reviews');
              }
            });

            if ($(".spr-review").length <= 3) {
              $(".read-all-reviews").hide();
            }

            $t.find(".new-review-form").submit(function(e) {
              var $form = $(this);
              console.log($form.attr("class"));
              var submittedTimer = setInterval(function() {
                var $form = $(".spr-form.active .new-review-form");
                var $r = $form.parents("#reviews").first();
                console.log("msg len: " + $form.find(".spr-form-message").length);
                if ($form.find(".spr-form-message").length) {
                  clearInterval(submittedTimer);
                  var $formContainer = $(".spr-form.active");
                  $formContainer.prepend('<button class="overlay-blur skip-btn-style"><span class="displace">Close</span></button>');
                  $formContainer.find(".new-review-form").prepend('<button class="x-close skip-btn-style"><span class="displace">Close</span></button>');
                  $formContainer.find(".overlay-blur,.x-close").click(function(e) {
                    e.preventDefault();
                    var $p = $(this).parents(".spr-form").first();
                    $p.hide().removeClass("active");
                  })
                }

              }, 20)
            })


            $badge.addClass("init");


            $t.removeClass("init");
          }, 100)



        }

      }, 100)
    })

    $(".nav .style-menu-tab").each(function(e) {
      $(this).click(function(e) {
        e.preventDefault();

        var $p = $(this).parent(".nav-item");
        if (!$p.hasClass("nav--active")) {
          var group = $(this).attr("data-group");
          var $t = $(".style-guide-grids");
          if ($t.length) {
            $p.siblings(".nav--active").removeClass("nav--active");
            $p.addClass("nav--active");
            if (group == "all") {
              $t.find(".style-guide-grid").show();
            } else {
              $t.find(".style-guide-grid:not(." + group + ")").hide();
              $t.find(".style-guide-grid." + group).show();
            }

          }
        }

      })
    })


    // FILTERS
    $(".filter-main-toggle").click(function(e) {
      e.preventDefault();
      var $p = $(this).siblings(".filters__body").first();

      if ($(this).hasClass("active")) {
        S.scroll.enable() // $("html, body").removeClass("disable-scroll-zoom");
        $p.removeClass("active");
        $(this).removeClass("active");
      } else {
//         S.scroll.disable($p.find("[body-scroll-lock-ignore]"));
        $p.addClass("active");
        $(this).addClass("active");
      }
    })

    S.content.makeFilterTags();

    $(".filters .overlay-blur, .filters .x-close").click(function(e) {
      e.preventDefault();
      $(this).parents(".filters").find(".filter-main-toggle").trigger("click");
    })

    $(".filter--sort .filter__item a").click(function(e) {
      e.preventDefault();
      // console.log("a lick????");
      var $btn = $(this).parents(".filters").find(".close-btn");
      setTimeout(function() {
        var url = $btn.attr("href");
          window.location.href = url;
      }, 100)

      // console.log($(this).parents(".filters").find(".close-btn").length);
      // $(this).parents(".filters").find(".close-btn").trigger("click");
    })


    $(".filter__item").click(function(e) {
      var $p = $(this).parents(".filters__body");
      var $p2 = $(this).parents('.filter');

      if (!$(this).hasClass("filter__item--active")) {
        $(this).addClass("filter__item--active");
        $p2.addClass('button-active');
        $(this).siblings().removeClass("filter__item--active");
      } else {
        $(this).removeClass("filter__item--active");
        $p2.removeClass('button-active');
      }
      $p2.removeClass('active');
      $p2.find('.filter-label').removeClass('active');
      S.content.makeFilterTags();
      var $close = $p.find(".close-btn");
      var url = $(this).attr('data-url');
      setTimeout(function() {
        if(url == undefined){
          url = $close.attr("href");
        }
        console.log(url)
        window.location.href = url;
      }, 150)
    })

    $(".filter-label").click(function() {
      var $p = $(this).parents(".filter").first();
      if ($p.hasClass("active")) {
        $p.removeClass("active");
        $(this).removeClass("active");
        $(".filters").removeClass("expanded");
      } else {
        $p.siblings().find(".filter-label.active").removeClass("active");
        $p.siblings().removeClass("active");
        $p.addClass("active");
        $(this).addClass("active");
        if ($p.hasClass("filter--size") || $p.hasClass("filter--color")) {
          $(".filters").addClass("expanded");
        } else {
          $(".filters").removeClass("expanded");
        }
      }
    })





    $('.quickshop-btn.desktop-only').mouseover(function(e) {
      e.preventDefault();
      var $p = $(this).parents(".quickshop-marker").first();
        $p.addClass("active");
    })

    $('.quickshop-btn.device-only').click(function(e) {
      e.preventDefault();
      var $p = $(this).parents(".quickshop-marker").first();
      console.log($p.attr("class"));
      if ($p.hasClass("active")) {
        $p.removeClass("active");
      } else {
        $p.addClass("active");
      }
    })



    $(".quickshop-marker").mouseleave(function(e) {
      e.preventDefault();
      $(this).removeClass("active");
    })

    $("body").on('click','.quickshop-hover-add',function(e) {
      e.preventDefault();
      var isWishlist = ($('body').attr('class').indexOf('wishlist')>-1 ? true:false);
      var $this = $(this);
      var $p = $(this).parents(".product-item");
      var current_selected = $p.find('.selected-size');
      var current_selected_text = String($p.find('.selected-size').text());
      var $size = $p.find("input[name=size]:checked");
        console.log('line 2377',$size)
      if (($size.length && current_selected_text.indexOf('Select ') == -1 ) || isWishlist) {
        current_selected.removeClass('error');
        var size = $size.attr("value");
        var $trigger = $p.find(".quick-add__button[data-size='"+size+"']");
        // if(isWishlist){
        //   size = $this.attr('data-size');
        //   $trigger = $p.find(".quick-add__button[data-size='"+size+"']");
        // }
        if ($trigger.length) {
          $trigger.trigger("click");
          $('.full-looks').removeClass('active');
          $('.custom-popup').removeClass('open-popup');
          $('.body--page-community').removeClass('popup-open');
        }
      }
      else{
        current_selected.addClass('error');
      }
    })
    
    $(".order-form__atc").click(function(e) {
      e.preventDefault();

      var $p = $(this).parents(".product-info");
      var isGC = JSON.parse($p.find('.addtoform').attr('data-product-giftcart'));
      var current_selected = $p.find('.selected-size');      
      var current_selected_text = $p.find('.selected-size .selected-val');
      var $size = $p.find("input[class=option__input]:checked");
      console.log("is GC", isGC);
//       if($size.length === 0){
//       console.log('gift card');
//         var $size = $p.find("input[name=gift-card]:checked");
//       }
            
      
//       console.log($size)
      var seleceted_bool = ($p.find('.selected-size .selected-val').attr('data-selected')!= undefined)?$.parseJSON(($p.find('.selected-size .selected-val').attr('data-selected')).toLowerCase()):false;
//       console.log($p.find('.option--size span.selected-val').attr('data-selected'),current_selected_text,seleceted_bool);
//       console.log((($size.length > 0 && seleceted_bool == true)));
//       if ($size.length && current_selected_text.indexOf('Select a Size') == -1 ) {
      if(isGC==true){
        $size = $p.find("input[class=option__input]:checked");
      }
      console.log($size,$size.val())
      if ($size.length > 0 && seleceted_bool == true) {
        current_selected_text.attr('data-selected',true);
        $p.find('.option.option--size .selected-val').removeClass('error');
        current_selected.removeClass('error');
        var size = $size.attr("value");
//         console.log(size);
        var $trigger = $p.find(".quick-add__button[data-size='"+size+"']");
//         console.log($trigger);
        console.log('$trigger',$trigger.length);
        if ($trigger.length) {
          $trigger.trigger("click");
          $('.full-looks').removeClass('active');
          $('.custom-popup').removeClass('open-popup');
          $('.body--page-community').removeClass('popup-open');
        }
      }
      else{
        console.log('2435')
        $p.find('.option.option--size .selected-val').addClass('error');        
        current_selected.addClass('error');
        return false;
      }
    })
   
    
    if($('body').hasClass('body--page-community')){
      $("body").on('click','.shop-full-look[data-id]',function(e) {
        e.preventDefault();
        console.log($(this).parents('.swiper-container').find('.swiper-slide-active').find('a.shop-full-look.accent-bg.type-d.desktop-only'))
        var id = $(this).parents('.swiper-container').find('.swiper-slide-active').find('a.shop-full-look.accent-bg.type-d.desktop-only').attr("data-id");
        var $t = $(".full-looks[data-id='"+id+"']");
        console.log($t,id)
        S.scroll.disable($t.find("[body-scroll-lock-ignore]"))
        $t.addClass("active");
        //S.scroll.disable();
      })
    }
    else{
      $("body").on('click','.shop-full-look-placeholder',function(e) {
//         $('.swiper-slide-active > .shop-look-item > .block-interior > .shop-full-look.desktop-only').click();
      })
           
      
      $("body").on('click','.shop-full-look[data-id]',function(e) {
        e.preventDefault();
        console.log('click on shop');
//         console.log($(this).parents('.swiper-container').find('.swiper-slide-active').find('a.shop-full-look.accent-bg.type-d.desktop-only'))
        var id = $(this).parents('.js-style-guide-wrapper.show').find('.swiper-slide-active').find('a.shop-full-look.accent-bg.type-d.desktop-only').attr("data-id");
        var $t = $(".full-looks[data-id='"+id+"']");
        console.log($t,id)
        S.scroll.disable($t.find("[body-scroll-lock-ignore]"))
        $t.addClass("active");
        //S.scroll.disable();
      })
    }
    
    

    $(".full-looks").each(function() {
      $(this).find(".overlay-blur, .x-close").click(function(e) {
        // S.scroll.enable() // $("html, body").removeClass("disable-scroll-zoom");
//         S.scroll.enable()
        $(this).parents(".full-looks").first().removeClass("active");
//         $('body').removeClass('disabled-scroll');
        $('html,body').removeClass('disabled-scroll');
//         $("body").removeClass("scroll-disabled");
      })
      $(this).find(".quickshop-hover-add").click(function(e) {
        e.preventDefault();
        var $p = $(this).parents(".product-item").first();
        var current_selected = $p.find('.selected-size');
        var current_selected_text = String($p.find('.selected-size').text());
        var $size = $p.find("input[name=size]:checked");
        console.log('line 2489',$size,current_selected_text)
        if ($size.length && current_selected_text.indexOf('Select ') == -1 ) {
          current_selected.removeClass('error');
          var size = $size.attr("value");
          var $trigger = $p.find(".quick-add__button[data-size='"+size+"']");
          if ($trigger.length) {
            $trigger.trigger("click");
            $('.full-looks').removeClass('active');
            $('.custom-popup').removeClass('open-popup');
            $('.body--page-community').removeClass('popup-open');
          }
        }
        else{
          console.log('from ehre',current_selected)
          current_selected.addClass('error');
        }
//         var $p = $(this).parents(".full-looks");
//         $p.removeClass("active");
//         S.scroll.enable()
        // S.scroll.enable() // $("html, body").removeClass("disable-scroll-zoom");
      })
      $(this).find(".full-looks-add-all").click(function(e) {
        e.preventDefault();
        var $p = $(this).parents(".full-looks");
        $p.find(".quickshop-hover-add").each(function() {
          $(this).trigger("click");
        })
        $('.full-looks').removeClass('active');
        $('.custom-popup').removeClass('open-popup');
        $('.body--page-community').removeClass('popup-open');
      })
    })

    $("body").on('click','.option-name-click',function(e) {
      e.preventDefault();
      var $p = $(this).parents(".js-mobile-options");
      var $b = $p.find(".option-bucket");
      if ($b.hasClass("active")) {
        $(this).removeClass("active");
        $b.removeClass("active");
      } else {
        $b.addClass("active");
        $(this).addClass("active");
        $p.siblings(".option").find(".option-bucket.active").removeClass("active");
      }
    })

    $(".header").hover(function() {
      $(this).addClass("header--toggled");
      if($(".header-wrapper").hasClass('header-sticky')){
        $(this).addClass("header--toggled");
      }
    }, function() {
//       console.log($(".header-wrapper").hasClass('header-sticky'))
      if($(".header-wrapper").hasClass('header-sticky')){
        $(this).addClass("header--toggled");
      }
      else{
        $(this).removeClass("header--toggled");
      }
    })

    $(".nav-item.with-subnav.top-level").hoverIntent(function() {
      $(this).find(".subnav").addClass("expanded");
    }, function() {
      $(this).find(".subnav").removeClass("expanded");
    })

    $(".nav-search").click(function(e) {
      e.preventDefault();
      var $h = $(".header, .header-wrapper");
      var $t = $h.find(".search-wrapper");
      if ($t.hasClass("active")) {
        $t.removeClass("active");
        $h.removeClass("search-open");
      } else {
        $t.addClass("active");
        $h.addClass("search-open");
        $('.search__input').focus();
      }
    })

    $(".search-wrapper .overlay-blur, .search-wrapper .sm-x-close").click(function(e) {
      e.preventDefault();
      $(".modal").removeClass("active");
      $(this).parents(".search-wrapper").removeClass("active");
      $(".header,.header-wrapper").removeClass("search-open");
    })

    $(".search__clear").click(function(e) {
      e.preventDefault();
      var $p = $(this).parents(".search-wrapper.mode--results");
      $p.find("input.search__input").attr("value", "").focus();
      $(this).remove();
      $p.siblings().remove();
      $p.find("form.search--results").siblings().addClass("invisible");
    })

    $(".page--cart .cart-item__quantity .item-quantity__button").click(function() {
      $(".cart-wrapper").addClass("faded");
      setTimeout(function() {
        $("button.cart__update").trigger("click");
      }, 20)
    })

    $(".mini-cart").find(".x-close,.overlay-blur").click(function(e) {
      e.preventDefault();


      var $t = $(this).parents(".mini-cart");
      // console.log("mini cart x close click!!! " + $t.attr("class"));
      $t.removeClass("active");
      $(".header, .header-wrapper, .collection").removeClass("mini-cart-open");
      // console.log("hi?")

    })

    $(".option__content").each(function() {
      $(this).find(".option__item").on('click',function() {
        $(this).parents(".option__content").first().find("button.option__name").trigger("click");
      })

      $(this).find("button.option__name").on('click',function(e) {
        e.preventDefault();
        var $p = $(this).parents(".option__content").find(".dropdown-menu");
        if ($p.hasClass("active")) {
          $p.removeClass("active");
          $(this).removeClass("active");
        } else {
          $p.addClass("active");
          $(this).addClass("active");
        }
//         console.log($('body').hasClass('body--cart'))
      })
    })

    $(".order-form .swatch.colorway-link").click(function() {
      $("article.product").addClass("fade-out");
    })



    // between colorway links with zoom open, set cookie to auto-open zoom on the next page
    $(".product-zoom .colorway-link").click(function() {
      Cookies.set("showZoom", 'true');
    });

    var zoomCookie = Cookies.get("showZoom");
    if (zoomCookie == 'true' && $(".product-zoom").length) {
      $(".product .product-gallery-container [data-high-res-img]").first().trigger("click");
    }
    if (zoomCookie) {
      Cookies.remove("showZoom");
    }



    $(".tab[data-target]").click(function(e) {
      e.preventDefault();
      var id = $(this).attr("data-target");
      $(this).addClass("active");
      $(this).siblings(".active").removeClass("active");

      var $t = $("[data-tab-id='"+id+"']");
      $t.addClass("active");
      $t.siblings(".active").removeClass("active");
    })


    $(".col-toggles").each(function() {
      $(".toggle-two").click(function(e) {
        e.preventDefault();
        if (!$(this).hasClass("active")) {
          $(this).parents(".col-toggles").first().removeClass("init");
          $(this).siblings(".active").removeClass("active");
          $(this).addClass("active");
          $(".collection-grids").removeClass("col-four col-one").addClass("col-two");
          var allProdImages = $('.product-item__image img');
//           $.each(allProdImages,function(index,ele){
// //             console.log($(ele).attr('data-2xsrc'))
//             $(ele).attr('src',$(ele).attr('data-2xsrc'));
//           })

          if (S.isTablet) {
            Cookies.remove("togglePreferenceTablet");
            // console.log("clear tablet toggle preference");
          } else if (S.isMobile) {
            Cookies.set("togglePreferenceMobile", 'toggle-two');
            // console.log("set mobile toggle preference: toggle-two");
          } else {
            Cookies.set("togglePreference", 'toggle-two');
            // console.log("set desktop toggle preference: toggle-two");
          }
        }

      })
      $(".toggle-one").click(function(e) {
        e.preventDefault();
        if (!$(this).hasClass("active")) {
          $(this).parents(".col-toggles").first().removeClass("init");
          $(this).siblings(".active").removeClass("active");
          $(this).addClass("active");
          $(".collection-grids").removeClass("col-four col-two").addClass("col-one");
          if (S.isMobile) {
            Cookies.remove("togglePreferenceMobile");
            // console.log("clear mobile toggle preference");
          } else if (S.isTablet) {
            Cookies.set("togglePreferenceTablet", 'toggle-one');
            // console.log("set tablet toggle preference: toggle-one");
          }
        }
      })
      $(".toggle-four").click(function(e) {
        e.preventDefault();
        if (!$(this).hasClass("active")) {
          $(this).parents(".col-toggles").first().removeClass("init");
          $(this).siblings(".active").removeClass("active");
          $(this).addClass("active");
          $(".collection-grids").removeClass("col-two col-one").addClass("col-four");
          var allProdImages = $('.product-item__image img');
//           $.each(allProdImages,function(index,ele){
// //             console.log($(ele).attr('data-4xsrc'))
//             $(ele).attr('src',$(ele).attr('data-4xsrc'));
//           })
          Cookies.remove("togglePreference");
          // console.log("clear desktop toggle preference: toggle-one");
        }
      })

    //   console.log("isMObile: " + S.isMobile + " / " + Cookies.get("togglePreferenceMobile"));
      // console.log("isTablet: " +  S.isTablet + " / " + Cookies.get("togglePreferenceTablet"));
      // console.log("isDesktop: " + S.isDesktop + " / " + Cookies.get("togglePreference"));

      if (S.isTablet && Cookies.get("togglePreferenceTablet")) {
        // console.log("tablet toggle preference found: " + Cookies.get("togglePreferenceTablet"));
        $("."+Cookies.get("togglePreferenceTablet")).trigger("click");
      } else if (S.isMobile && Cookies.get("togglePreferenceMobile")) {
        // console.log("mobile toggle preference found: " + Cookies.get("togglePreferenceMobile"));
        $("."+Cookies.get("togglePreferenceMobile")).trigger("click");
      } else if (S.isDesktop && Cookies.get("togglePreference")) {
        // console.log("desktop toggle preference found: " + Cookies.get("togglePreference"));
        $("."+Cookies.get("togglePreference")).trigger("click");
      }
      else{
        
        if(S.isMobile){
        $(".toggle-two").trigger("click");
        }
        else{
          $(".toggle-one").trigger("click");
        }
        
      }
    })


    // $(window).resize(function(){
    //   if(S.isMobile && $('.collection-grids').hasClass('col-one')){
    //     console.log('toggle mobile on resize')
    //   $(".toggle-two").trigger("click");
    //   }
    //   else{
    //     $(".toggle-one").trigger("click");
    //   }
    // })

    $(".collections-promo-insert").each(function() {
      if ($(this).find(".grid-item-promo")) {
        $(this).find(".grid-item-promo").unwrap();
      } else {
        $(this).remove();
      }
    })


    $(".careers-content__opportunity-content").each(function() {
      var $t = $(this).siblings(".careers-content__opportunity-title").first();
      var title = $t.find(".careers-content__opportunity-title-position").text();
      var location = $t.find(".careers-content__opportunity-title-location").text();

      var html = '<a href="mailto:get@argentwork.com?subject=Application for '+title+', '+location+'" class="btn accent apply-btn">Apply</a>';
      $(this).find(".share").before(html);
    })

    $("input[type=file].form-upload").each(function() {
      $(this).on("change", function(){
        if ($(this)[0].files && $(this)[0].files.length > 0 ) {
          $(this).addClass("uploaded");
          $(this).siblings(".filename").remove();
          $(this).after('<div class="type-e filename">'+$(this)[0].files[0].name+'</div>');
        } else {
          $(this).removeClass("uploaded");
          $(this).siblings(".filename").remove();
        }
      });
    })



    $(".klaviyo_submit_button").click(function(e) {
      var $f = $(this).parents("form").first();
      $f.find("input[required]").each(function() {
        var val = $(this).val();
		$('.error-message').remove();
        if (val.trim() == "") {
          $(this).addClass("error").after('<span class="error-message type-e">Required</span>');
        }
        else {
          if ($(this).attr('type') == 'email' && !validateEmail(val)) {
            $(this).addClass("error").after('<span class="error-message type-e">Invalid Email</span>');
          }
          else if ($(this).attr('type') == 'text' && !validatePostalCode(val)) {
            $(this).addClass("error").after('<span class="error-message type-e">Invalid Postal Code</span>');
          }
          else {
            $(this).removeClass("error");
            $(this).siblings(".error-message").remove();
          }
        }

        $(this).focus(function() {
          $(this).removeClass("error");
          $(this).siblings(".error-message").remove();
        })
      })
    })

    function validateEmail(e) {
        var re = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        return re.test(String(e).toLowerCase());
    }

    function validatePostalCode(e) {
        var re = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
        return re.test(e);
    }

    // Account Page Form Toggles

    //Initialize state dropdowns.
    var $addForm = $(".account-address-form");
    // new Shopify.CountryProvinceSelector('customer-addr-new-country', 'customer-addr-{{ address_id }}-province', {hideElement: 'account-form__province-new'});
    $addForm.each(function() {
        var add_id = $(this).attr("data-address-id");
        new Shopify.CountryProvinceSelector('customer-addr-' + add_id + '-country', 'customer-addr-' + add_id + '-province', {hideElement: 'account-form__province-' + add_id});
        //var defaultState = $('.province-select[data-default]').attr("data-default"); $('.province-select > option').each(function(){ if ('[value]' == defaultState){ $(this).attr('selected', 'selected'); } });
    });

    $('.province-select').prepend($('<option disabled selected value>State</option>'));
    $('.province-select').prop("selectedIndex", 0);

    $(".account-dashboard .edit-address").click(function() {
      $(".customer-account__address-new").hide();
      $(".customer-account__details").css('padding-bottom', '0' );
      $(".address__preview-full").hide();
      $(".address__actions").hide();
      $(".address__preview-edit-text").text('Edit Address').show();
    })
    $(".account-dashboard .cancel-edit").click(function() {
      $(".customer-account__address-new").show();
      $(".customer-account__details").css('padding-bottom', 'inherit' );
      $(".address__preview-full").show();
      $(".address__actions").show();
      $(".address__preview-edit-text").hide();
    })

    $(".customer-account__address-new button").click(function() {
      $(".customer-account__details").css('padding-bottom', '0' );
      $(".address__preview-full").hide();
      $(".address__actions").hide();
      $(".address__preview-edit-text").html('Add Address').show();
      $(this).hide();
    })

    $(".save-address + button").click(function() {
      $('.customer-account__address-new button').show();
    })


    // intro loader vs. not
    if ($("body").hasClass("body--index")) {
      // S.loader.init();
    } else {
      $("body").removeClass("init");
      S.content.cookieBar();
      setTimeout(function() {
        S.content.emailPop();
      }, 5000)
    }





    /*
    var headerHeight = $(".header").outerHeight();
    console.log("headerHeight: " + headerHeight);

    var watchers = $('.scrollfix').map(function(i, element) {
    var watcher = scrollMonitor.create( element, headerHeight );
    watcher.lock();
    watcher.stateChange(function() {
      $(element).toggleClass('fixed', this.isAboveViewport)
    });
    return watcher;
  }); */
    $("#page-content").removeClass("init");
  }





  S.init = function() {
    // console.log("init");
    var $c = $("#page-content");



    // S.nav.init();
    S.scroll.action();
    $(window).bind("scroll", S.scroll.action);

    S.size.all();
    S.content.init($c);

    // $(".mini-cart").removeClass("active");

    setTimeout(function() {
      S.size.all();
      $(window).resize(function() {
        S.resizeTimer && clearTimeout(S.resizeTimer);
        S.resizeTimer = setTimeout(S.size.all, 300);
      });


      if ($(".collection-nav-wrapper").length) {
        S.scroll.collectionWatcher = scrollMonitor.create($(".collection-nav-wrapper"), S.size.header);
        S.scroll.collectionWatcher.lock();
//         console.log(S.scroll.collectionWatcher.isInViewport)
        if (S.scroll.collectionWatcher.isAboveViewport) {
          $(".collection.container").addClass('collection-nav-sticky');
        }
        S.scroll.collectionWatcher.stateChange(function() {
          $(".collection.container").toggleClass('collection-nav-sticky', this.isAboveViewport);
        });
      }


      if ($(".faq-content__categories").length) {
        S.scroll.collectionWatcher = scrollMonitor.create($(".faq-content__categories"), S.size.header);
        S.scroll.collectionWatcher.lock();
        if (S.scroll.collectionWatcher.isAboveViewport) {
          $(".support-interior").addClass('nav-sticky');
        }
        S.scroll.collectionWatcher.stateChange(function() {
          $(".support-interior").toggleClass('nav-sticky', this.isAboveViewport);
        });
      }


      if ($(".promo-bar").length) {
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (iOS) {
        	S.scroll.headerWatcher = scrollMonitor.create($(".promo-bar"), -36);
        }
        else {
        	S.scroll.headerWatcher = scrollMonitor.create($(".promo-bar"));
        }

        S.scroll.headerWatcher.lock();
        S.scroll.headerWatcherAction = function(t) {
          if (S.scroll.headerWatcher.isAboveViewport && !S.scroll.headerWatcher.isInViewport) {
            $(".header").removeClass("with-promo-bar");
//             console.log('with-promo-bar removed')
          } else {
            $(".header").addClass("with-promo-bar");
          }
        }
        S.scroll.headerWatcherAction();
        S.scroll.headerWatcher.stateChange(function() {
          S.scroll.headerWatcherAction();
        });
      }


      S.scroll.productWatcher = scrollMonitor.create($(".product-lower"));
      S.scroll.productWatcher.lock();
      S.scroll.productWatcherAction = function(t) {
        if (S.scroll.productWatcher.isInViewport || S.scroll.productWatcher.isAboveViewport) {
          $(".product-info").addClass('product-info--notsticky');
        } else {
          $(".product-info").removeClass('product-info--notsticky');
        }
      }
      S.scroll.productWatcherAction();
      S.scroll.productWatcher.stateChange(function() {
        if (this.isInViewport || this.isAboveViewport) {
          $(".product-info").addClass('product-info--notsticky');
          $(".product-info .order-form").addClass('absolute');
        } else {
          $(".product-info").removeClass('product-info--notsticky');
          $(".product-info .order-form").removeClass('absolute');
        }
      });


      S.scroll.faqWatchers = [];
      var f = 2;
      $(".faq-content__category-link").click(function(e) {
        e.preventDefault();
        var id = $(this).attr("href");
        var top = $(id).offset().top + S.size.windowH*-0.4;
        window.scrollTo({
          top: top,
          behavior: 'smooth',
          block: 'center'
        });
      })

      $(".faq-content__category").each(function() {
        // console.log(f);
        S.scroll.faqWatchers[f] = scrollMonitor.create($("#questions-" + f), S.size.windowH*-0.5);
        // console.log("#questions-" + f);
        if (S.scroll.faqWatchers[f].isInViewport) {
          var id = $(this.watchItem).attr("id");
          var $tab = $(".faq-content__category-link[href='#"+id+"']");
          $tab.addClass("active");
          $tab.siblings(".active").removeClass("active");
        }
        S.scroll.faqWatchers[f].enterViewport(function() {
          var id = $(this.watchItem).attr("id");
          var $tab = $(".faq-content__category-link[href='#"+id+"']");
          $tab.addClass("active");
          $tab.siblings(".active").removeClass("active");
        });
        f++;
      })

      if ($(".expandable-text[id]").length) {
          var hash = window.location.hash;
          if (hash) {
            var $t = $(hash);
            if ($t.length) {
              var $e = $t.find(".expandable-title");
              $e.trigger("click");

              setTimeout(function() {
                console.log($t.offset().top);
                var top = $t.offset().top + S.size.windowH*-0.4;
                console.log("top: " + top);
                window.scrollTo({
                  top: top,
                  behavior: 'smooth',
                  block: 'top'
                });
              }, 80);

            }
          }
      }


    }, 100)


  }

//   $('.strHtml').liMarquee({circular:true, startShow:true, scrollDelay: 0,scrollamount:100,drag:false});

  S.init();


//   function Utils() {

//   }

//   Utils.prototype = {
//     constructor: Utils,
//     isElementInView: function (element, fullyInView) {
//       var pageTop = $(window).scrollTop();
//       var pageBottom = pageTop + $(window).height();
//       var elementTop = $(element).offset().top;
//       var elementBottom = elementTop + $(element).height();

//       if (fullyInView === true) {
//         return ((pageTop < elementTop) && (pageBottom > elementBottom));
//       } else {
//         return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
//       }
//     }
//   };

//   var Utils = new Utils();

  
//   $(window).scroll(function(){
//     var isElementInView = Utils.isElementInView($('#job-companies'), false);
//     if (isElementInView) {
// //       console.log('in view');
// //       $('.job-logo-tab, .job-submit-resume').addClass('position-sticky');
//     } else {
// //       console.log('out of view');
// //       $('.job-logo-tab, .job-submit-resume').removeClass('position-sticky');
//     }
    
//   })
  
  
  function stikcyTabandButton(){
    var distance = ($('#shopify-section-job_landing_company_logo').offset().top - $('.header').height()),
        $window = $(window);

    $window.scroll(function() {
      if ( ($window.scrollTop()) >= distance ) {
        // Your div has reached the top
//         console.log('in view');
        $('.job-logo-tab, .job-submit-resume').addClass('position-sticky');
//         console.log('reached at top');
      }
      else{
        $('.job-logo-tab, .job-submit-resume').removeClass('position-sticky');
//         console.log('xxx');
      }
    });
  }

  if($('#shopify-section-job_landing_company_logo').length>0){
    stikcyTabandButton();
    $(window).resize(function() {
      stikcyTabandButton();
    });
  }

//   if ($(".job-logo-wapper").length) {
//     var $footer = $('#shopify-section-featured-products');
//     var stickyEle = $('.job-submit-resume');
//     var classToAdd= 'fixed';
//     var $logoWrapper = $('.job-logo-wapper');
//     var LogoWatcher = scrollMonitor.create( $logoWrapper );
// //     var blurWatcher = scrollMonitor.create($('#shopify-section-job_landing_blurb'))
//     var footerWatcher = scrollMonitor.create($footer);
//     LogoWatcher.lock();
// //     blurWatcher.lock();
// //     footerWatcher.lock();
//     var LogoWatcherAction = function(t) {
//       if (LogoWatcher.isFullyInViewport) {
//         stickyEle.addClass(classToAdd);
//       } 
// //       if(LogoWatcher.isAboveViewport) {
// //         stickyEle.removeClass(classToAdd);
// //       }
//     }
//     LogoWatcherAction();
//     LogoWatcher.stateChange(function() {
//       console.log(this.offsets)
//       if (this.isFullyInViewport) {
//         stickyEle.addClass(classToAdd); 
//       } 
//       else{
// //         stickyEle.removeClass(classToAdd);
//       }
// //       if(LogoWatcher.isAboveViewport) {
// //         stickyEle.removeClass(classToAdd);
// //       }
//     });

//     footerWatcher.exitViewport(function(){
//       stickyEle.removeClass(classToAdd);
//     })

//   }

});



$(document).ready(function(){
  
  if(Cookies.get('discount_code')){
    var discount= Cookies.get('discount_code');
    var curr_action = $('form[action*="\cart"]').attr('action');
    $('form[action*="\cart"]').attr('action',curr_action+"?discount="+discount)
  }
  else{
    var curr_action = $('form[action*="\cart"]').attr('action');
    $('form[action*="\cart"]').attr('action',curr_action+"?discount=%20");
  }
  
 /*JS for Job page */
  if($('body').hasClass('body--page-job-landing')){
    $('.job-submit-resume a').on('click',function(){
      $('.thankyou-popup').hide();
      $('.job-popup__content').show();
      $("#job-application-popup").addClass('active');
    })
    $("#js-file-trigger").on('click',function(){
      $("#ResumeFile").trigger('click')
    })

    $("#ResumeFile").on('change',function(){
      var file_name = $(this).val().split('\\').pop();
      $("#selected_file").text('').text('Selected file: '+file_name).css({'padding-top':"10px"});
      if(file_name.length>0){
        $('#ResumeFile-error').remove();
      }
    })
    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(appURL+"/Company/getAllCompany", requestOptions)
    .then(response => response.text())
    .then(result => {
      //     console.log(result)
      var strHTML = '';
      var allData = JSON.parse(result);
      var allCompns = allData.companies;
      var categories = allData.categories;
      var allCates = `<li class="nav-item nav--active"><a href="javascript:;" data-filter="*" class="nav-link">All</a></li>`;
      $.each(categories,function(index,ele){
        if(ele){
          var active = (index==0)?'active':'';
          allCates += `<li class="nav-item "><a href="javascript:;" data-filter="${ele}" class="nav-link">${ele}</a></li>`;
        }
      })
      $('.tab-filter').empty().html(allCates);
      //     console.log(categories)
      var companyOpt = '';
      companyOpt += `<option value="">Select Company</option>`;
      $.each(allCompns,function(index,ele){
        if(ele){
          strHTML += `<div class="job-logo-innner" data-filter="${ele.category_name}"><a href="${ele.job_url}" target="_blank" data-company="${ele.company_name}" data-id="${ele.id}" data-category="${ele.category_name}">`;
          strHTML += `<img data-src="${appURL+'/Image/'+ele.company_logo}" class="lazyload" />`;
          strHTML += `</a></div>`;
          companyOpt += `<option value="${ele.id}">${ele.company_name}</option>`;
        }
      })
      $("#company").empty().html(companyOpt);
      $('#company').select2();
      $('.job-logo-wapper').empty().html(strHTML);

    })
    .catch(error => console.log('error', error));


    // This will hold the handle of the child window
    var __CHILD_WINDOW_HANDLE_2 = null;

    $('#linkedin-button').on('click', function() {
      //     __CHILD_WINDOW_HANDLE_2 = window.open('https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=783vklm6cek63n&redirect_uri='+appURL+'/login/Index&state=987654321&scope=r_liteprofile%20r_emailaddress', 'popup_window', 'width=700,height=500,left=200,top=100');
      __CHILD_WINDOW_HANDLE_2 = window.open('https://stalwartdigital.com/linkedin-login/login/callback.php', 'popup_window', 'width=700,height=500,left=500,top=100');

      //     OAuth.initialize('-5vwhr117qaRq97XoxXGPKCY2vc')
      //     OAuth.popup('linkedin2').done(function(result) {
      // //       console.log(result)
      //       // do some stuff with result
      //       result.me().done(function(data) {
      //         console.log(data)
      //         if(data){
      //         $("#fullname").val(data.name);
      //           $("#job_email").val(data.email);
      //         }
      //         // do something with `data`, e.g. print data.name
      //       })
      //     })
    })

    window.addEventListener('message', function(e) {
      ProcessChildMessage_2(e.data);
    } , false);

    function ProcessChildMessage_2(message) {
      if(typeof(message) == "string"){
        if(message != "undefined"){
          console.log(message)
          var data = JSON.parse(message.replace(/&quot;/g,'"'));
          $("#fullname").val(data.firstName + " " + data.lastName);
          $("#job_email").val(data.email);
        }
      }
      //     $("#message-from-container-2").append(message);
    }


    $(document).on('click','.tab-filter li a',function(){
      //hide all works by default 
      $(".job-logo-innner").addClass('filter-hide');
      //show slected works based on the menu clicked
      //     console.log($(this).attr('data-filter'))
      $(".job-logo-innner[data-filter*='"+$(this).attr('data-filter')+"']").removeClass("filter-hide");
      //remove selected class to the link      
      $('.tab-filter li.nav-item a').parent().removeClass('nav--active');
      //add selected class to the active link
      $(this).parent().addClass('nav--active');
    });
    //show all works for "all" menu
    $(document).on('click','.nav-item a[data-filter="*"]',function(event) {    
      $(".job-logo-innner").removeClass('filter-hide');
      return false;
    });

    $(document).on('click','.filter-elements .job-logo-innner a',function(){
      var company_name = $(this).attr('data-id');
      $("#company option[value='"+company_name+"']").attr('selected','selected');
      $('#company').val(company_name); // Select the option with a value of '1'
      $('#company').trigger('change'); // Notify any JS components that the value changed
    })


    $.ajax({
      type: 'GET',
      url: appURL+'/token/create',
      dataType: "json",
      success: function(data) {
        var token= data.token;
        $("#token").val(token);
      },
      error: function(data, textStatus, jqXHR) {
        console.log(data);
        console.log(textStatus);
        console.log(jqXHR);
      }
    });

    $('#company').on('select2:select', function (e) {
      // Do something
      var data = e.params.data;
      //     console.log(data);
      if(data.selected){
        $("#company-error").remove();
      }
    });


    var jobForm = $('#jobpost_form');
    if(jobForm.length){
      jobForm.validate({
        rules: {
          fullname: "required",
          job_url: {
            required: true,
            url: true
          },
          email: {
            required: true,
            email: true
          },
          linkedin_url:{
            url:true,
          },
          company: "required",
          ResumeFile:{
            required: true
          }
        },
        messages: {
          fullname: "Please enter name",
          company: "Please select company",
          email: "Please enter a valid email address",
          job_url: {
            required: 'Please enter Job URL',
            url: 'Please enter valid URL'
          },
          linkedin_url:{
            url:'Please enter valid URL',
          },
          ResumeFile:{
            required: "Please upload a Resume"
          }
        },
        errorPlacement: function (error, element) {
          console.log(element.attr("type"),element)
          if (element.attr("id") == "company") {
            error.insertAfter($(element).siblings('.select2-container'));
          } 
          else if (element.attr("id") == "ResumeFile") {
            error.insertAfter($('#js-file-trigger'))
          }
          else {
            error.insertAfter($(element))
          }
        },
        submitHandler: function(form) {
          //       $('input[type="submit"]',jobForm).prop('disabled', true);
          //       form.submit();
          var formData = {
            fullname: $("#fullname").val(),
            email: $("#job_email").val(),
            linkedin_url: $("#linkedin_url").val(),
            token:$("#token").val(),       
            company:$("#company").val(),
            ResumeFile:$("#ResumeFile").val(),
            job_url:$("#job_url").val()
          };
          // Get form
          var form = $('#jobpost_form')[0];
          // Create an FormData object 
          var data = new FormData(form);
          // If you want to add an extra field for the FormData
          data.append("fullname", $("#fullname").val());
          data.append("email", $("#job_email").val());
          data.append("linkedin_url", "");
          data.append("token", $("#token").val());
          data.append("company", $("#company").val());
          data.append("ResumeFile", $("#ResumeFile").val());
          data.append("job_url", $("#job_url").val());
          //       console.log(jobForm.find('input[type="submit"]'))
          jobForm.find('button[type="submit"]').text('Submitting...');
          //       console.log(data);
          if($("#token").val().length>0){
            $.ajax({
              type: "POST",
              url: appURL+"/job/create",
              data: data,
              contentType: false,
              processData: false,
              cache: false,
              success: function(data) {
                console.log('from submitdata');
                console.log(data);
                jobForm.find('button[type="submit"]').text('Submit Application');
                if(data){
                  $("#jobpost_form").trigger('reset')
                  $('.job-popup__content').hide();
                  $('.thankyou-popup').show();
                  $("#selected_file").text('');
                  $("#company option:eq(0)").attr('selected','selected')
                  //               setTimeout(function(){
                  //                 $("#jobpost_form").trigger('reset')
                  //                 $('.job-popup__content').show();
                  //                 $('.thankyou-popup').hide();
                  //                 $("#company option:eq(0)").attr('selected','selected')
                  //               }, 3000);
                }
              },
              error: function(data, textStatus, jqXHR) {
                //process error 
                console.log(data);
                console.log(textStatus);
                console.log(jqXHR);
              }
              // encode: true,
            }).done(function (data) {

            });
          }
          else{
            alert('Invalid Request, please try again later');
          }
        }
      });
    }

  } /*JS for Job page */
  
  
  
  var $productOptions = $('.product-info__content .options-wrapper');
  if($productOptions.length > 0){
    //   Color value get start
    var $defualtHover =".product_colors .option.option--color.default-color .option-bucket .option__values-wrapper .option__values .option-value";
    var $seasonalHover=".product_colors .option.option--color.seasonal-color .option-bucket .option__values-wrapper .option__values .option-value";

    var $defaultColor =$('.product_colors .option.option--color.default-color .option-bucket .option__values-wrapper .option__values .option-value.active input').val();
    var $seasonalColor =$('.product_colors .option.option--color.seasonal-color .option-bucket .option__values-wrapper .option__values .option-value.active input').val();


    $($defualtHover).mouseenter(function(){
      var $currentColor=$.trim($(this).attr('data-color'));
      console.log($currentColor,$(this))
      
      $('.options-wrapper .option__name').find('#default-color-value').text($currentColor);
    });
    $($defualtHover).mouseleave(function(){
      if($defaultColor === undefined){
        $defaultColor="";
      }
      $('.options-wrapper .option__name').find('#default-color-value').text($defaultColor);
      //console.log('$currentColor');
    });


    $($seasonalHover).mouseenter(function(){
      var $currentColor=$.trim($(this).attr('data-color'));
      console.log($currentColor);    
      $('.options-wrapper .option__name').find('#default-color-value').text($currentColor);
    });
    $($seasonalHover).mouseleave(function(){
      console.log($seasonalColor);
      if($seasonalColor === undefined){
        $seasonalColor="";
      }
      $('.options-wrapper .option__name').find('#default-color-value').text($seasonalColor);    
    });

//     console.log($defaultColor);
//     console.log($seasonalColor);

    //   Color value get end
    if($defaultColor !== undefined ){
      $('.options-wrapper .option__name').find('#default-color-value').text($defaultColor);
    }
//     if($seasonalColor !== undefined ){
//       $('.product_colors .seasonal-color .option__name').find('#seasonal-color-value').text($seasonalColor);
//     }
  }
  
  /* Quick Add Adjustment - mobile */
  $('body').on('click','span.device-only.js_trigger_mobile_quickcart a',function(e){
    e.preventDefault();
    $(this).hide();
    var ele = $(this).parents('.product-item').find('.js_element_mobile_quickcart');
    $(this).parents('.product-item').addClass('quickadd-enabled');
    ele.show();
  })


  if (S.size.windowW <= 1024) {
    $('li.nav-item.top-level.with-subnav').on('click',function(e){
      var $nav = $(this).closest('nav.nav-main'),
          $ul = $(this).closest('ul.nav-interior'),
          $nav_utility = $(this).closest('.nav-wrapper-interior').find('nav.nav-utility>ul'),
          $li = $(this),
        $submenu = $(this).closest('.nav-item');
        js_menu_back = $('.js-menu-back');
      $ul.addClass('active-child');
      $li.addClass('active-child');
      $submenu.addClass('active-child');
      // console.log($nav_utility)
      $nav_utility.addClass('active-child');
      js_menu_back.show();
    })
    $('.js-menu-back').on('click',function(){
      var $nav = $('nav.active-child, ul.active-child,li.active-child');
      var $this= $(this);
      $nav.removeClass('active-child');
      $this.hide();
    })
    $('li.nav-item.child-link-title>.nav-link').on('click',function(){
      var $nav = $(this).parents('.child-link-title');
      console.log($(this))
      $nav.toggleClass('active-child');
    })
  }
      function hasAudio (video) {
        // console.log(video)
                video.addEventListener("complete", function() {
        if (typeof this.webkitAudioDecodedByteCount !== "undefined") {
          // non-zero if video has audio track
          if (this.webkitAudioDecodedByteCount > 0)
            console.log("video has audio");
          else
            console.log("video doesn't have audio");
        }
        else if (typeof this.mozHasAudio !== "undefined") {
          // true if video has audio track
          if (this.mozHasAudio)
            console.log("video has audio");
          else
            console.log("video doesn't have audio");
        }
        else
          console.log("can't tell if video has audio");
        });
      }

function checkMutedVideos(){
   var videos_check = $('video');
    $.each(videos_check,function(index,ele){
      var js_video = $(ele)[0];
      hasAudio(js_video);
      // console.log($(ele).closest('.video-wrapper').find('.mute-video'))
      // if(hasAudio(js_video)) {   
      //   $(ele).closest('.video-wrapper').find('.mute-video').show()
      // }
      // else {
      //   $(ele).closest('.video-wrapper').find('.mute-video').hide();
      // };
    })
}
  checkMutedVideos();
   
  $(".mute-video").click( function (e){
    e.preventDefault();
    var videos = $(this).closest('.swiper-slide').find('video');
    $.each(videos,function(index,ele){
        var video = $(ele);
      if($(window).width()<798){
        //mobile video
        // video = $('.desktop-hidden',$(ele));
            if($(ele).hasClass('desktop-hidden')){
              console.log(video)
              mute_unmuted_video(video)
            }
      }
      else{
        //desktop video
      if($(ele).hasClass('desktop-only')){
          console.log(video)
          mute_unmuted_video(video)
        }
      }
        
    })
  });

  function mute_unmuted_video(video){
    if(video.prop('muted')){
        video.prop('muted', false)
        $(video).parents('.video-wrapper').find('.mute-video').addClass('muted-off');
        $(video).parents('.video-wrapper').find('.mute-video').removeClass('muted-on');
      }
      else{
        video.prop('muted', true)
        $(video).parents('.video-wrapper').find('.mute-video').addClass('muted-on');
        $(video).parents('.video-wrapper').find('.mute-video').removeClass('muted-off');
      }
  }
    if(S.size.windowW > 1024){
      $(document).on("click",".read_more_btn",function(){ 
        var parent = $(this).closest('.product-item');
        var count = parent.find('.hide-colors');
        console.log("count",count);
        count.removeClass('hide-colors');
        // $(this).removeClass("mobile-load-less");
        // count.attr('class',$('.load-less').attr('class').replace('load-less','load-more'));
        
        parent.find('.read_more_btn').hide();
      }); 
    }else{
       $(document).on("click",".mobile_read_more_btn",function(){
        var parent = $(this).closest('.product-item');
        var count=  parent.find('.mobile-hide-colors');
        count.removeClass('mobile-hide-colors')
        count.removeClass('one_side_mobile-hide-colors') 
        console.log("count",count);
        parent.find('.mobile_read_more_btn').hide();
        parent.find('.one_mobile_read_more_btn').hide(); 
      }); 

      $(document).on("click",".one_mobile_read_more_btn",function(){
        var parent = $(this).closest('.product-item');
        var count=  parent.find('.one_side_mobile-hide-colors');
        count.removeClass('one_side_mobile-hide-colors')
        count.removeClass('hide-colors')
        console.log("count",count);
        parent.find('.one_mobile_read_more_btn').hide();
        
      }); 
      
    }
      var current = location.pathname;
    $('ul.nav_sidebar_account li a').each(function(){
        var $this = $(this);
        // if the current path is like this link, make it active
       if ($this.attr('href') === current) {
        if($this.attr('href').indexOf(current) !== -1){
            $this.addClass('active');
        }
       }   
    })

$('body').on('click','.yotpo-nav-tab',function(e){
  var tab_type = $(this).attr('data-type')
      if(tab_type=='reviews'){
        $('.write-question-review-button.write-review-button').show();
        $('.write-question-review-button.write-question-button').hide();
      }
  else{
       $('.write-question-review-button.write-review-button').hide();
        $('.write-question-review-button.write-question-button').show();   
  }
  console.log(tab_type)
})

$('body').on('click','.wishlist .product-item__swatch',function(){
  var t = $(this);
  var color_price= t.parents('.color-label').attr('data-price');
  // console.log(color_price)
  var final = t.parents('.product-item__info').find('.product-item--price');
  final.attr("data-product-price",color_price).text(color_price);
})

  $('body').on('click','[data-add-address-btn]',function(e){
    $('.add_address_label').removeClass('hide')
  })
  $('body').on('click','[data-cancel-address-form]',function(e){
    $('.add_address_label').addClass('hide')
  })

  var login_form = $("#customer_login").validate();
  $("#customer_login").submit(function(event) {
    $('.login-error').html('').addClass('hide');
    if(!login_form.valid()){
      $('.login-error').html('Please re-enter your correct email or password.').removeClass('hide');
      event.preventDefault();
      return false;
    }
    //submit via ajax
  });
  
  
}) /*Ends Document ready */

document.addEventListener('DOMContentLoaded', function() {
    $(document).on("swell:initialized", function() {
      console.log('swell:initialized')
      var old_element = document.querySelector(".yotpo-login-link button");
      var new_element = old_element.cloneNode(true);
      old_element.parentNode.replaceChild(new_element, old_element);
      $(new_element).on('click',function(e){
        e.preventDefault();
        $('html').css({overflow: 'hidden'});
        $('#login-popup .content-box').show();
        $("#login-popup").addClass('active');
      })
    // do something using my campaigns or redemption options
    })
});